(function () {
'use strict';
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
const RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
const cents = n => Math.round(n * 100);
const fmt = n => '$' + (cents(n) / 100).toFixed(2);
const store = {
  get(k, d) { try { const v = localStorage.getItem(k); return v == null ? d : JSON.parse(v); } catch (e) { return d; } },
  set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
};
const PHOTO = document.getElementById('pooterPhoto') ? document.getElementById('pooterPhoto').getAttribute('src') : '';

/* ---------------- landing in the right place on load and reload ----------------
   Phones (iPhone Safari above all) restore the old scroll position, or jump to #shop, before the fonts and
   the 3D Pooter have finished sizing the page. Everything above then grows and the visitor ends up further
   down on every refresh. Instead: with a #section in the address, keep that section at the top until the
   page settles; on a plain reload, go back to the same spot in the same section. Any touch, wheel or key
   from the visitor stops the correcting at once. */
(() => {
  const KEY = 'fc-spot';
  const nav = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
  const reload = nav ? nav.type === 'reload' : !!(performance.navigation && performance.navigation.type === 1);
  const sections = () => $$('main section[id]');
  const hashEl = location.hash.length > 1 ? document.getElementById(decodeURIComponent(location.hash.slice(1))) : null;
  let target = null;
  const hashSec = hashEl ? hashEl.closest('section[id]') : null;
  if (hashSec) target = { id: hashSec.id, hash: true };
  else if (reload) { try { target = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) {} }
  addEventListener('pagehide', () => {
    if (document.documentElement.classList.contains('pp-open')) return;   // the game covers the page
    const list = sections(); let cur = null;
    list.forEach(sec => { if (sec.getBoundingClientRect().top <= 90) cur = sec; });
    const spot = cur ? { id: cur.id, off: Math.round(scrollY - (cur.getBoundingClientRect().top + scrollY)) } : { id: null, off: Math.round(scrollY) };
    try { sessionStorage.setItem(KEY, JSON.stringify(spot)); } catch (e) {}
  });
  if (!target) return;
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  let done = false;
  const stop = () => { done = true; };
  ['touchstart', 'wheel', 'keydown', 'mousedown'].forEach(t => addEventListener(t, stop, { passive: true, capture: true, once: true }));
  const align = () => {
    if (done) return;
    let y;
    if (target.hash) {
      const el = document.getElementById(target.id); if (!el) return;
      y = el.getBoundingClientRect().top + scrollY - (parseFloat(getComputedStyle(el).scrollMarginTop) || 0);
    } else {
      const el = target.id ? document.getElementById(target.id) : null;
      y = (el ? el.getBoundingClientRect().top + scrollY : 0) + (target.off || 0);
    }
    y = Math.max(0, Math.round(y));
    if (Math.abs(scrollY - y) > 1) scrollTo({ top: y, left: 0, behavior: 'instant' });
  };
  align();
  requestAnimationFrame(align);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(align);
  addEventListener('load', align);
  // keep it in place while the page finishes laying out, then let go
  const ro = 'ResizeObserver' in window ? new ResizeObserver(align) : null;
  if (ro) ro.observe(document.body);
  const finish = () => { done = true; if (ro) ro.disconnect(); };
  addEventListener('load', () => setTimeout(finish, 1500));
  setTimeout(finish, 9000);
})();

/* ---------------- toast ---------------- */
const toastEl = $('#toast'); let toastTimer = 0;
function toast(msg) {
  toastEl.textContent = msg; toastEl.classList.add('show');
  clearTimeout(toastTimer); toastTimer = setTimeout(() => toastEl.classList.remove('show'), 3400);
}

/* ---------------- phone menu: "More" opens every section link ---------------- */
(() => {
  const btn = $('#moreBtn'), menu = $('#moreMenu');
  if (!btn || !menu) return;
  const set = open => { menu.hidden = !open; btn.setAttribute('aria-expanded', open ? 'true' : 'false'); };
  btn.addEventListener('click', e => { e.stopPropagation(); set(menu.hidden); });
  menu.addEventListener('click', e => { if (e.target.closest('a')) set(false); });
  document.addEventListener('click', e => { if (!menu.hidden && !menu.contains(e.target) && !btn.contains(e.target)) set(false); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && !menu.hidden) { set(false); btn.focus(); } });
  const wide = matchMedia('(min-width: 901px)');
  const onWide = () => { if (wide.matches) set(false); };
  if (wide.addEventListener) wide.addEventListener('change', onWide); else if (wide.addListener) wide.addListener(onWide);
})();

/* =========================================================
   SOUND — real Pooter recordings only
   Every sound on the page is one of Jack's recorded clips, decoded
   once with Web Audio and played through one gentle compressor and
   an analyser (which drives the Toot Lab visualizer and logo puffs).
   ========================================================= */
const CLIP_URLS = (window.FARTS_URLS && window.FARTS_URLS.clips) || {};
const Sound = (() => {
  let ctx = null, master, analyser, td, fd;
  let muted = !!store.get('fc-muted', false);
  const clips = {}, pending = {}, voices = {};

  function build() {
    const AC = window.AudioContext || window.webkitAudioContext; if (!AC) return null;
    try { ctx = new AC(); } catch (e) { ctx = null; return null; }
    master = ctx.createGain(); master.gain.value = 0.9;
    const comp = ctx.createDynamicsCompressor(); comp.threshold.value = -14; comp.knee.value = 10; comp.ratio.value = 4;
    analyser = ctx.createAnalyser(); analyser.fftSize = 1024; analyser.smoothingTimeConstant = 0.55;
    master.connect(comp); comp.connect(analyser); analyser.connect(ctx.destination);
    td = new Uint8Array(analyser.fftSize); fd = new Uint8Array(analyser.frequencyBinCount);
    return ctx;
  }
  function ensure() {
    if (!ctx || ctx.state === 'closed') {
      if (!build()) return null;
      load('pooter16');
      setTimeout(() => Object.keys(CLIP_URLS).forEach(load), 250);   // warm up the rest so pads play instantly
    }
    wake();
    return ctx;
  }
  // Coming back to the page. iOS leaves the audio "interrupted" (not "suspended") after the visitor switches
  // apps or locks the phone, and only a tap can start it again, so resume it from whatever state it is in.
  // If it then says "running" but its clock never moves (a WebKit bug after long stays in the background),
  // throw it away and start a fresh one: the recordings are decoded again on the next squeeze.
  let checking = false, rebuilds = 0;
  function wake() {
    if (!ctx) return;
    if (ctx.state !== 'running') { try { const p = ctx.resume(); if (p && p.catch) p.catch(() => {}); } catch (e) {} }
    if (checking || document.hidden) return;
    checking = true;
    const c0 = ctx, t0 = ctx.currentTime;
    setTimeout(() => {
      checking = false;
      if (c0 !== ctx || document.hidden) return;
      if (ctx.state === 'running' && ctx.currentTime === t0 && rebuilds < 2) { rebuilds++; rebuild(); }
    }, 450);
  }
  function rebuild() {
    try { ctx.close(); } catch (e) {}
    Object.keys(voices).forEach(k => { voices[k] = null; });
    Object.keys(clips).forEach(k => { delete clips[k]; });
    Object.keys(pending).forEach(k => { delete pending[k]; });
    ctx = null; ensure();
  }
  document.addEventListener('visibilitychange', () => {
    if (!ctx) return;
    if (document.hidden) { if (ctx.state === 'running') ctx.suspend().catch(() => {}); }
    else wake();
  });
  window.addEventListener('pageshow', () => { if (ctx) wake(); });
  ['pointerdown', 'touchend', 'keydown'].forEach(type => document.addEventListener(type, () => { if (ctx && ctx.state !== 'running') wake(); }, { capture: true, passive: true }));

  // trim the silent head/tail, level the peak, and keep a 60 fps loudness envelope for animation
  function analyse(buf) {
    const chs = []; for (let c = 0; c < buf.numberOfChannels; c++) chs.push(buf.getChannelData(c));
    const N = buf.length, sr = buf.sampleRate;
    let pk = 0; for (const d of chs) for (let i = 0; i < N; i++) { const a = Math.abs(d[i]); if (a > pk) pk = a; }
    const th = pk * 0.03, loud = i => chs.some(d => Math.abs(d[i]) > th);
    let first = 0; while (first < N - 1 && !loud(first)) first++;
    let lastI = N - 1; while (lastI > first && !loud(lastI)) lastI--;
    const off = Math.max(0, first / sr - 0.01), end = Math.min(buf.duration, lastI / sr + 0.06), dur = end - off;
    const step = Math.max(1, Math.round(sr / 60)), env = [];
    for (let s0 = Math.round(off * sr); s0 < Math.round(end * sr); s0 += step) {
      let e = 0, n = 0;
      for (let i = s0; i < Math.min(N, s0 + step); i++, n++) { let v = 0; for (const d of chs) v += d[i]; v /= chs.length; e += v * v; }
      env.push(Math.sqrt(e / Math.max(1, n)));
    }
    const em = Math.max(...env) || 1;
    for (let i = 0; i < env.length; i++) env[i] = Math.pow(Math.min(1, env[i] / em), 0.6);
    const COLS = 480, a0 = Math.round(off * sr), span = Math.max(1, Math.round(end * sr) - a0), peaks = new Float32Array(COLS);
    for (let c = 0; c < COLS; c++) {
      const i0 = a0 + Math.floor(c * span / COLS), i1 = Math.min(N, a0 + Math.floor((c + 1) * span / COLS));
      let m = 0; for (let i = i0; i < i1; i++) for (const d of chs) { const a = Math.abs(d[i]); if (a > m) m = a; }
      peaks[c] = m;
    }
    let pm = 0; for (let c = 0; c < COLS; c++) if (peaks[c] > pm) pm = peaks[c];
    for (let c = 0; c < COLS; c++) peaks[c] = Math.pow(peaks[c] / (pm || 1), 0.75);
    return { buf, off, dur, env, peaks, gain: Math.min(8, 0.95 / (pk || 1)) };
  }
  function load(id) {
    if (clips[id]) return Promise.resolve(clips[id]);
    if (pending[id]) return pending[id];
    if (!ctx || !CLIP_URLS[id]) return Promise.resolve(null);
    pending[id] = fetch(CLIP_URLS[id])   // same-origin request with the visitor's cookies, so it also works on a login-locked preview
      .then(r => { if (!r.ok) throw new Error('audio ' + r.status); return r.arrayBuffer(); })
      .then(ab => new Promise(res => {
        let settled = false;
        const ok = buf => { if (settled) return; settled = true; try { clips[id] = analyse(buf); } catch (e) { clips[id] = null; } res(clips[id]); };
        const bad = () => { if (settled) return; settled = true; res(null); };
        try { const p = ctx.decodeAudioData(ab, ok, bad); if (p && p.catch) p.catch(bad); } catch (e) { bad(); }
      }))
      .then(c => { if (!c) pending[id] = null; return c; })
      .catch(() => { pending[id] = null; return null; });
    return pending[id];
  }
  function stopVoice(group) {
    const v = voices[group]; if (!v) return; voices[group] = null;
    const t = ctx.currentTime; v.g.gain.cancelScheduledValues(t); v.g.gain.setTargetAtTime(0, t, 0.02);
    try { v.src.stop(t + 0.12); } catch (e) {}
  }
  // plays a whole clip and resolves with its timing + envelope (still resolves when muted, so visuals run).
  // clips in the same group cut each other off (the Toot Lab pads).
  async function playClip(id, group) {
    const c = ensure(); if (!c) return null;
    const cl = await load(id); if (!cl) return null;
    if (group) stopVoice(group);
    if (!muted) {
      const g = c.createGain(); g.gain.value = cl.gain; g.connect(master);
      const src = c.createBufferSource(); src.buffer = cl.buf; src.connect(g);
      src.start(c.currentTime, cl.off, cl.dur);
      const v = { src, g }; if (group) voices[group] = v;
      src.onended = () => { try { g.disconnect(); } catch (e) {} if (group && voices[group] === v) voices[group] = null; };
    }
    return cl;
  }
  function level() {
    if (!ctx) return 0; analyser.getByteTimeDomainData(td);
    let s = 0; for (let i = 0; i < td.length; i += 4) { const v = (td[i] - 128) / 128; s += v * v; }
    return Math.sqrt(s / (td.length / 4));
  }
  function freq() { if (!ctx) return null; analyser.getByteFrequencyData(fd); return fd; }
  // Squeezing the 3D Pooter plays a different recording each time: all seven, shuffled,
  // before any repeats, and never the same one twice in a row.
  const SQUEEZES = ['pooter16', 'finale', 'surprise', 'straight', 'daddy', 'getaway', 'momma'];
  let bag = [], lastSqueeze = '';
  function nextSqueeze() {
    if (!bag.length) {
      bag = SQUEEZES.slice();
      for (let i = bag.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [bag[i], bag[j]] = [bag[j], bag[i]]; }
      if (bag[bag.length - 1] === lastSqueeze) [bag[0], bag[bag.length - 1]] = [bag[bag.length - 1], bag[0]];
    }
    return (lastSqueeze = bag.pop());
  }
  return {
    ensure, playClip, level, freq,
    squeeze: () => playClip('pooter16'),
    squeezeAny: () => playClip(nextSqueeze()),
    time: () => td,
    get muted() { return muted; },
    setMuted(m) { muted = m; store.set('fc-muted', m); if (m && ctx) Object.keys(voices).forEach(stopVoice); },
    get ready() { return !!ctx; }
  };
})();

/* mute button */
const muteBtn = $('#muteBtn');
function syncMute() {
  muteBtn.setAttribute('aria-pressed', String(Sound.muted));
  muteBtn.setAttribute('aria-label', Sound.muted ? 'Unmute sounds' : 'Mute sounds');
  muteBtn.innerHTML = Sound.muted ? '<svg><use href="#i-mute"/></svg>' : '<svg><use href="#i-sound"/></svg>';
}
syncMute();
muteBtn.addEventListener('click', () => { Sound.setMuted(!Sound.muted); syncMute(); toast(Sound.muted ? 'Sound off.' : 'Sound on.'); });

/* =========================================================
   POOTER SHAPE — matches the real product:
   black rubber body with a pinched waist, a rounded glossy cap that
   sits a little wider than the body, a shallow dish with the air hole
   in the center, and a banded, recessed underside.
   Units: cap diameter = 2, height = 2.28. Pairs are [radius, height].
   ========================================================= */
const PROFILE = (() => {
  // Measured from the studio product photo (cap diameter = 2 units).
  const P = [];
  const pt = (r, y) => P.push([r, y]);
  const arc = (cx, cy, R, a0, a1, n) => { for (let i = 1; i <= n; i++) { const a = (a0 + (a1 - a0) * i / n) * Math.PI / 180; P.push([cx + R * Math.cos(a), cy + R * Math.sin(a)]); } };
  // flat bottom with a small rounded edge
  pt(0.0005, -1.108); pt(0.3, -1.108); pt(0.6, -1.108); pt(0.837, -1.108); P.outerStart = P.length - 1;
  arc(0.837, -1.068, 0.04, 270, 360, 8);
  // body: straight sides that taper slightly toward the bottom
  for (let k = 1; k <= 20; k++) { const y = -1.068 + (1.618 * k) / 20; pt(0.877 + 0.067 * Math.pow(Math.max(0, (y + 1.0) / 1.55), 1.3), y); }
  // seam groove where the cap meets the body
  pt(0.938, 0.585);
  P.capStart = P.length; pt(0.936, 0.6);
  // cap: only a little wider than the body, short rounded side
  pt(0.952, 0.606); pt(0.966, 0.614); pt(0.977, 0.635); pt(0.988, 0.67); pt(0.992, 0.705); pt(0.996, 0.775); pt(1.0, 0.845); pt(1.0, 0.915);
  pt(0.995, 0.951); pt(0.985, 0.986); pt(0.968, 1.021); pt(0.944, 1.056); pt(0.905, 1.083); pt(0.86, 1.099); pt(0.82, 1.106);
  pt(0.78, 1.108); P.rim = P.length - 1;
  // flat top face
  pt(0.66, 1.108); pt(0.54, 1.108); pt(0.465, 1.107);
  // polished countersink down to the air hole
  P.coneStart = P.length; pt(0.448, 1.104); pt(0.436, 1.098);
  pt(0.38, 1.067); pt(0.3, 1.022); pt(0.22, 0.977); pt(0.172, 0.951);
  P.holeStart = P.length; pt(0.156, 0.944); pt(0.146, 0.932); pt(0.141, 0.9); pt(0.14, 0.78); pt(0.14, 0.62);
  return P;
})();
const OUTER = [[0.0005, -1.14]].concat(PROFILE.slice(PROFILE.outerStart, PROFILE.rim + 1));
function pooterPath(S, cx, cy, flip) {
  const m = (x, y) => [cx + x * S, flip ? cy + y * S : cy - y * S];
  const right = OUTER.map(p => m(p[0], p[1])), left = OUTER.slice().reverse().map(p => m(-p[0], p[1]));
  return 'M' + right.concat(left).map(p => p[0].toFixed(2) + ' ' + p[1].toFixed(2)).join(' L') + ' Z';
}
$$('[data-pooter]').forEach(el => { const [S, cx, cy, f] = el.dataset.pooter.split(',').map(Number); el.setAttribute('d', pooterPath(S, cx, cy, !!f)); });

/* 3/4 view icon of the real Pooter (used where WebGL isn't available) */
const pooterIcon = () => `<svg viewBox="0 0 100 128" aria-hidden="true">
  <ellipse cx="50" cy="120" rx="40" ry="6" fill="rgba(18,22,31,.18)"/>
  <path d="M8.5 44 L11 111 Q11.5 113.5 14 114 A36 8 0 0 0 86 114 Q88.5 113.5 89 111 L91.5 44 Z" fill="#0d0d0f"/>
  <path d="M13 60 L15 108 L21 110 L19 58 Z" fill="#fff" opacity=".05"/>
  <path d="M6 44 V35 A44 12 0 0 1 94 35 V44 A44 10 0 0 1 6 44 Z" fill="#121215"/>
  <path d="M8.5 46.5 A41.5 9 0 0 0 91.5 46.5" fill="none" stroke="#000" stroke-width="1.4" opacity=".8"/>
  <ellipse cx="50" cy="33.5" rx="43" ry="11.5" fill="#1a1a1e"/>
  <path d="M9 36 A41 10.5 0 0 0 91 36" fill="none" stroke="#fff" stroke-opacity=".16" stroke-width="2"/>
  <path d="M20 29 A32 7 0 0 1 58 23.5" fill="none" stroke="#fff" stroke-opacity=".2" stroke-width="2.4" stroke-linecap="round"/>
  <ellipse cx="50" cy="34" rx="16" ry="4.4" fill="#101013"/>
  <ellipse cx="50" cy="34.6" rx="4.6" ry="1.9" fill="#000"/>
</svg>`;

/* spec drawing */
(function specDrawing() {
  const svg = $('#specDrawing'); if (!svg) return;
  const S = 118, cx = 220, cy = 238;
  const X = x => cx + x * S, Y = y => cy - y * S;
  const mirror = pts => { const R = pts.map(p => [X(p[0]), Y(p[1])]), L = pts.slice().reverse().map(p => [X(-p[0]), Y(p[1])]); return 'M' + L.concat(R).map(p => p[0].toFixed(1) + ' ' + p[1].toFixed(1)).join(' L'); };
  const dish = mirror(PROFILE.slice(PROFILE.rim));
  const t = Y(1.108), b = Y(-1.108), l = X(-1.0), r = X(1.0);
  const tag = (x, y, s) => `<circle cx="${x}" cy="${y}" r="10" class="bp-tag"/><text x="${x}" y="${y + 0.5}" class="bp-tag-t">${s}</text>`;
  svg.innerHTML = `
    <text x="22" y="30" class="bp-text">DWG FC-0001 · Side elevation</text>
    <line x1="${cx}" y1="${t - 40}" x2="${cx}" y2="${b + 22}" class="bp-axis"/>
    <path d="${pooterPath(S, cx, cy, false)}" class="bp-fill"/>
    <path d="${pooterPath(S, cx, cy, false)}" class="bp-line"/>
    <path d="${dish}" class="bp-dash"/>
    <line x1="${X(-0.936)}" y1="${Y(0.6)}" x2="${X(0.936)}" y2="${Y(0.6)}" class="bp-thin"/>
    <line x1="${l}" y1="${b + 8}" x2="${l}" y2="${b + 46}" class="bp-thin"/>
    <line x1="${r}" y1="${b + 8}" x2="${r}" y2="${b + 46}" class="bp-thin"/>
    <line x1="${l}" y1="${b + 38}" x2="${r}" y2="${b + 38}" class="bp-thin"/>
    <path d="M${l} ${b + 38}l8 -4v8zM${r} ${b + 38}l-8 -4v8z" fill="rgba(196,218,243,.7)"/>
    <rect x="${cx - 52}" y="${b + 30}" width="104" height="16" fill="#12161F"/>
    <text x="${cx}" y="${b + 41.5}" text-anchor="middle" class="bp-dim">FITS ONE PALM</text>
    <line x1="${l - 8}" y1="${t}" x2="${l - 46}" y2="${t}" class="bp-thin"/>
    <line x1="${l - 8}" y1="${b}" x2="${l - 46}" y2="${b}" class="bp-thin"/>
    <line x1="${l - 38}" y1="${t}" x2="${l - 38}" y2="${b}" class="bp-thin"/>
    <path d="M${l - 38} ${t}l-4 8h8zM${l - 38} ${b}l-4 -8h8z" fill="rgba(196,218,243,.7)"/>
    <text transform="translate(${l - 44} ${(t + b) / 2}) rotate(-90)" text-anchor="middle" class="bp-dim">POCKET-SIZED</text>
    <line x1="${cx}" y1="${Y(1.03)}" x2="${cx}" y2="62" class="bp-thin"/>
    ${tag(cx, 52, 'C')}<text x="${cx + 18}" y="56" class="bp-text">Air hole (to palm)</text>
    <line x1="${X(0.99)}" y1="${Y(0.9)}" x2="392" y2="112" class="bp-thin"/>
    ${tag(402, 112, 'A')}<text x="420" y="108" class="bp-text">Rounded</text><text x="420" y="122" class="bp-text">lip</text>
    <line x1="${X(0.9)}" y1="${Y(-0.2)}" x2="392" y2="262" class="bp-thin"/>
    ${tag(402, 262, 'B')}<text x="420" y="258" class="bp-text">Squeeze</text><text x="420" y="272" class="bp-text">body</text>
    <line x1="${X(0.86)}" y1="${Y(-1.08)}" x2="392" y2="352" class="bp-thin"/>
    ${tag(402, 352, 'D')}<text x="420" y="348" class="bp-text">Flat</text><text x="420" y="362" class="bp-text">base</text>
    <rect x="352" y="410" width="170" height="44" fill="none" stroke="rgba(196,218,243,.45)"/>
    <line x1="352" y1="432" x2="522" y2="432" stroke="rgba(196,218,243,.45)"/>
    <text x="362" y="425" class="bp-dim">THE ORIGINAL POOTER</text>
    <text x="362" y="447" class="bp-dim">BLACK · SINCE 2007</text>`;
})();

/* =========================================================
   3D — Three.js · photoreal Pooter kit
   Geometry comes from PROFILE (measured from product photos).
   Surface detail is generated procedurally from the close-up photos:
   satin rubber body with dust specks, a crease and mold parting line,
   a glossy cap with a matte top face and a polished countersink,
   and the embossed underside ("FARTS.COM", "Made in the USA",
   "The Pooter", cavity "2", center ring and U-shaped rib).
   ========================================================= */
const HAS3D = typeof window.THREE !== 'undefined';
const H = 1.108;

function cnv(w, h) { const c = document.createElement('canvas'); c.width = w; c.height = h; return c; }
function seeded(seed) { let s = seed >>> 0; return () => ((s = (Math.imul(s, 1664525) + 1013904223) >>> 0) / 4294967296); }
function blurCanvas(c, px) {
  const o = cnv(c.width, c.height), g = o.getContext('2d');
  g.filter = `blur(${px}px)`; g.drawImage(c, 0, 0); g.filter = 'none';
  return o;
}
/* height map (grayscale, white = raised) -> tangent-space normal map */
function heightToNormal(hc, strength, wrapX) {
  const w = hc.width, h = hc.height, src = hc.getContext('2d').getImageData(0, 0, w, h).data;
  const out = cnv(w, h), og = out.getContext('2d'), img = og.createImageData(w, h), d = img.data;
  const at = (x, y) => {
    if (wrapX) x = (x + w) % w; else x = x < 0 ? 0 : x >= w ? w - 1 : x;
    y = y < 0 ? 0 : y >= h ? h - 1 : y;
    return src[(y * w + x) * 4] / 255;
  };
  for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) {
    const dx = (at(x + 1, y) - at(x - 1, y)) * strength, dy = (at(x, y + 1) - at(x, y - 1)) * strength;
    const l = Math.hypot(dx, dy, 1), i = (y * w + x) * 4;
    d[i] = (-dx / l * 0.5 + 0.5) * 255; d[i + 1] = (dy / l * 0.5 + 0.5) * 255; d[i + 2] = (1 / l * 0.5 + 0.5) * 255; d[i + 3] = 255;
  }
  og.putImageData(img, 0, 0); return out;
}
function speckle(g, w, h, n, rnd, tone) {
  for (let i = 0; i < n; i++) {
    const x = rnd() * w, y = rnd() * h, r = rnd() < 0.92 ? 0.5 + rnd() * 0.7 : 1.1 + rnd() * 1.2, v = tone[0] + rnd() * (tone[1] - tone[0]);
    g.fillStyle = `rgba(${v},${v},${v + 3},${0.18 + rnd() * 0.32})`; g.beginPath(); g.arc(x, y, r, 0, 6.2832); g.fill();
  }
}

/* all procedural canvases are built once and shared by every stage */
const POOTER_TEX = (() => {
  if (!HAS3D) return null;
  const rnd = seeded(7);
  const capP = PROFILE.slice(PROFILE.capStart), n = capP.length;
  const vRow = (j, hgt) => (1 - j / (n - 1)) * hgt;
  const iRim = PROFILE.rim - PROFILE.capStart, iCone = PROFILE.coneStart - PROFILE.capStart, iHole = PROFILE.holeStart - PROFILE.capStart;

  /* ---- body (u around, v bottom -> seam) ---- */
  const BW = 2048, BH = 512;
  const bodyColor = cnv(BW, BH); { const g = bodyColor.getContext('2d');
    g.fillStyle = 'rgb(20,20,22)'; g.fillRect(0, 0, BW, BH);
    for (let i = 0; i < 40; i++) { const x = rnd() * BW, y = rnd() * BH, r = 40 + rnd() * 160, gr = g.createRadialGradient(x, y, 0, x, y, r); const v = rnd() < 0.5 ? 26 : 16; gr.addColorStop(0, `rgba(${v},${v},${v + 2},.35)`); gr.addColorStop(1, 'rgba(0,0,0,0)'); g.fillStyle = gr; g.fillRect(x - r, y - r, r * 2, r * 2); }
    speckle(g, BW, BH, 240, rnd, [85, 140]);
    const seam = g.createLinearGradient(0, 0, 0, 22); seam.addColorStop(0, 'rgba(0,0,0,.55)'); seam.addColorStop(1, 'rgba(0,0,0,0)'); g.fillStyle = seam; g.fillRect(0, 0, BW, 22);
  }
  const bodyRough = cnv(BW, BH); { const g = bodyRough.getContext('2d');
    g.fillStyle = 'rgb(140,140,140)'; g.fillRect(0, 0, BW, BH);
    for (let i = 0; i < 70; i++) { const x = rnd() * BW, y = rnd() * BH, rx = 30 + rnd() * 140, ry = 12 + rnd() * 40; const v = 95 + rnd() * 70;
      g.save(); g.translate(x, y); g.scale(1, ry / rx); const gr = g.createRadialGradient(0, 0, 0, 0, 0, rx); gr.addColorStop(0, `rgba(${v},${v},${v},.7)`); gr.addColorStop(1, `rgba(${v},${v},${v},0)`); g.fillStyle = gr; g.fillRect(-rx, -rx, rx * 2, rx * 2); g.restore(); }
    for (let i = 0; i < 6; i++) { const x = rnd() * BW, y = 120 + rnd() * 300, rx = 60 + rnd() * 90; g.save(); g.translate(x, y); g.scale(1, 0.35); const gr = g.createRadialGradient(0, 0, 0, 0, 0, rx); gr.addColorStop(0, 'rgba(70,70,70,.8)'); gr.addColorStop(1, 'rgba(70,70,70,0)'); g.fillStyle = gr; g.fillRect(-rx, -rx, rx * 2, rx * 2); g.restore(); }
  }
  const bodyHeight = cnv(BW, BH); { const g = bodyHeight.getContext('2d');
    g.fillStyle = 'rgb(128,128,128)'; g.fillRect(0, 0, BW, BH);
    const img = g.getImageData(0, 0, BW, BH), d = img.data;
    for (let i = 0; i < d.length; i += 4) { const v = 128 + (rnd() - 0.5) * 16; d[i] = d[i + 1] = d[i + 2] = v; }
    g.putImageData(img, 0, 0);
    // a horizontal crease on one side, like the real rubber
    g.lineCap = 'round';
    const crease = (y0, x0, x1, amp, wdt, a) => { g.strokeStyle = `rgba(20,20,20,${a})`; g.lineWidth = wdt; g.beginPath(); for (let x = x0; x <= x1; x += 8) { const y = y0 + Math.sin(x * 0.02) * amp + (rnd() - 0.5) * 1.5; x === x0 ? g.moveTo(x, y) : g.lineTo(x, y); } g.stroke(); };
    crease(177, 1640, 2000, 5, 5, 0.55); crease(163, 1700, 1900, 3, 3, 0.35); crease(194, 1760, 1960, 3, 3, 0.3);
    // mold parting lines (raised) on opposite sides
    g.fillStyle = 'rgba(200,200,200,.55)'; g.fillRect(BW * 0.25 - 1, 0, 3, BH); g.fillRect(BW * 0.75 - 1, 0, 3, BH);
    // soft dents
    for (let i = 0; i < 10; i++) { const x = rnd() * BW, y = 60 + rnd() * 380, r = 30 + rnd() * 80, gr = g.createRadialGradient(x, y, 0, x, y, r); gr.addColorStop(0, 'rgba(70,70,70,.5)'); gr.addColorStop(1, 'rgba(70,70,70,0)'); g.fillStyle = gr; g.fillRect(x - r, y - r, r * 2, r * 2); }
  }
  const bodyNormal = heightToNormal(blurCanvas(bodyHeight, 1.2), 2.2, true);

  /* ---- cap (u around, v seam -> air hole) ---- */
  const CW = 2048, CH = 512;
  const band = (g, j0, j1, style) => { const y1 = vRow(j0, CH), y0 = vRow(j1, CH); g.fillStyle = style; g.fillRect(0, y0, CW, y1 - y0); };
  const capColor = cnv(CW, CH); { const g = capColor.getContext('2d');
    g.fillStyle = 'rgb(13,13,14)'; g.fillRect(0, 0, CW, CH);
    band(g, iRim, iCone, 'rgb(27,27,29)');
    band(g, iHole, n - 1, 'rgb(4,4,5)');
    speckle(g, CW, vRow(iHole, CH), 60, rnd, [70, 120]);
    const lip = g.createLinearGradient(0, CH, 0, CH - 60); lip.addColorStop(0, 'rgba(0,0,0,.75)'); lip.addColorStop(1, 'rgba(0,0,0,0)'); g.fillStyle = lip; g.fillRect(0, CH - 60, CW, 60);
  }
  const capRough = cnv(CW, CH); { const g = capRough.getContext('2d');
    g.fillStyle = 'rgb(52,52,52)'; g.fillRect(0, 0, CW, CH);            // glossy rounded rim
    band(g, iRim, iCone, 'rgb(150,150,150)');                          // satin flat top face
    band(g, iCone, iHole, 'rgb(40,40,40)');                            // polished countersink
    band(g, iHole, n - 1, 'rgb(170,170,170)');                         // inside the hole
    for (let i = 0; i < 50; i++) { const x = rnd() * CW, y = rnd() * CH, r = 20 + rnd() * 70, v = 30 + rnd() * 60, gr = g.createRadialGradient(x, y, 0, x, y, r); gr.addColorStop(0, `rgba(${v + 40},${v + 40},${v + 40},.35)`); gr.addColorStop(1, 'rgba(0,0,0,0)'); g.fillStyle = gr; g.fillRect(x - r, y - r, r * 2, r * 2); }
    const dull = g.createLinearGradient(0, CH, 0, CH - 60); dull.addColorStop(0, 'rgb(215,215,215)'); dull.addColorStop(1, 'rgba(215,215,215,0)'); g.fillStyle = dull; g.fillRect(0, CH - 60, CW, 60);  // dull underside of the cap lip (seam reads as a dark line)
  }
  const capHeight = cnv(CW, CH); { const g = capHeight.getContext('2d');
    g.fillStyle = 'rgb(128,128,128)'; g.fillRect(0, 0, CW, CH);
    const img = g.getImageData(0, 0, CW, CH), d = img.data;
    for (let i = 0; i < d.length; i += 4) { const v = 128 + (rnd() - 0.5) * 7; d[i] = d[i + 1] = d[i + 2] = v; }
    g.putImageData(img, 0, 0);
    const y0 = vRow(iCone, CH), y1 = vRow(iRim, CH);
    g.fillStyle = 'rgba(210,210,210,.7)'; g.fillRect(CW * 0.12, y0, 3, y1 - y0);   // radial mold line on the top face
    g.fillStyle = 'rgba(200,200,200,.5)'; g.fillRect(CW * 0.62, vRow(iRim, CH), 3, CH - vRow(iRim, CH)); // parting line on the rim
  }
  const capNormal = heightToNormal(blurCanvas(capHeight, 1), 1.6, true);

  /* ---- embossed underside (planar) — traced from the real part ---- */
  const S = 1024, C = S / 2, R = S * 0.5 * (0.877 / 0.837);   // R = visible outer edge of the base, in texture px
  const bh = cnv(S, S); { const g = bh.getContext('2d');
    g.fillStyle = 'rgb(90,90,90)'; g.fillRect(0, 0, S, S);
    const img = g.getImageData(0, 0, S, S), d = img.data;
    for (let i = 0; i < d.length; i += 4) { const v = 90 + (rnd() - 0.5) * 10; d[i] = d[i + 1] = d[i + 2] = v; }
    g.putImageData(img, 0, 0);
    const ink = 'rgb(235,235,235)';
    g.fillStyle = ink; g.strokeStyle = ink; g.textAlign = 'center'; g.textBaseline = 'middle';
    const FONT = 'Arial, Helvetica, "Liberation Sans", sans-serif';
    // lettering on an arc, spaced by glyph width, tops facing the rim; spread = degrees between first and last glyph.
    // weight is dialled in with an outline stroke (canvas Arial only has regular/bold)
    const glyph = (c, stroke) => { g.fillText(c, 0, 0); if (stroke) { g.lineWidth = stroke; g.lineJoin = 'round'; g.strokeText(c, 0, 0); } };
    const arcText = (txt, rad, centerDeg, weight, px, sx, spreadDeg, stroke) => {
      g.font = `${weight} ${px}px ${FONT}`;
      const ch = [...txt], w = ch.map(c => g.measureText(c).width * sx);
      const n = ch.length, core = w.reduce((a, b) => a + b, 0) - w[0] / 2 - w[n - 1] / 2;
      const track = (rad * spreadDeg * Math.PI / 180 - core) / Math.max(1, n - 1);
      let s = -(core + track * (n - 1)) / 2;
      for (let i = 0; i < n; i++) {
        if (i > 0) s += w[i - 1] / 2 + track + w[i] / 2;
        const a = centerDeg * Math.PI / 180 + s / rad;
        g.save(); g.translate(C + Math.cos(a) * rad, C + Math.sin(a) * rad); g.rotate(a + Math.PI / 2); g.scale(sx, 1); glyph(ch[i], stroke); g.restore();
      }
    };
    arcText('FARTS.COM', R * 0.785, -93, 400, 142, 0.88, 108, 6);
    arcText('Made in the USA', R * 0.537, -91, 700, 60, 0.86, 82, 0);
    arcText('The Pooter', R * 0.7, 87, 400, 88, 0.9, 82, 4);      // reads upside-down, like the real part
    g.font = `400 54px ${FONT}`; g.save(); g.translate(C + Math.cos(1.52) * R * 0.5, C + Math.sin(1.52) * R * 0.5); glyph('2', 2.5); g.restore();
    g.lineWidth = 5; g.beginPath(); g.arc(C, C, R * 0.377, 0, 6.2832); g.stroke();           // centre ring
    // the U: a thin raised outline of a round-ended band hugging the lower rim
    const u = cnv(S, S), ug = u.getContext('2d'), rm = R * 0.705, hw = R * 0.11;
    ug.strokeStyle = ink; ug.lineCap = 'round';
    const uPath = () => { ug.beginPath(); ug.arc(C, C, rm, (193 * Math.PI) / 180, (-13 * Math.PI) / 180, true); };
    ug.lineWidth = hw * 2 + 5; uPath(); ug.stroke();
    ug.globalCompositeOperation = 'destination-out'; ug.lineWidth = hw * 2 - 5; uPath(); ug.stroke();
    g.drawImage(u, 0, 0);
  }
  const bottomNormal = heightToNormal(blurCanvas(bh, 1.2), 5, false);
  const bottomColor = cnv(S, S); { const g = bottomColor.getContext('2d');
    g.fillStyle = 'rgb(24,24,26)'; g.fillRect(0, 0, S, S);
    g.globalAlpha = 0.5; g.drawImage(blurCanvas(bh, 1), 0, 0); g.globalAlpha = 1;    // raised details catch a touch more light
    g.globalCompositeOperation = 'multiply'; g.fillStyle = 'rgb(40,40,42)'; g.fillRect(0, 0, S, S); g.globalCompositeOperation = 'source-over';
    speckle(g, S, S, 90, rnd, [80, 130]);
  }
  const bottomRough = cnv(S, S); { const g = bottomRough.getContext('2d');
    g.fillStyle = 'rgb(185,185,185)'; g.fillRect(0, 0, S, S);
    g.globalCompositeOperation = 'difference'; g.globalAlpha = 0.3; g.drawImage(bh, 0, 0); g.globalAlpha = 1; g.globalCompositeOperation = 'source-over';
  }
  return { bodyColor, bodyRough, bodyNormal, capColor, capRough, capNormal, bottomColor, bottomRough, bottomNormal };
})();

function shadowCanvas() {
  const c = cnv(256, 256), g = c.getContext('2d');
  const gr = g.createRadialGradient(128, 128, 0, 128, 128, 128);
  gr.addColorStop(0, 'rgba(18,22,31,0.85)'); gr.addColorStop(0.45, 'rgba(18,22,31,0.34)'); gr.addColorStop(1, 'rgba(18,22,31,0)');
  g.fillStyle = gr; g.fillRect(0, 0, 256, 256); return c;
}
const SHADOW_CANVAS = HAS3D ? shadowCanvas() : null;

/* studio environment: dark room, soft-edged softboxes and a window,
   so the glossy cap picks up believable reflections */
function makeEnv(renderer) {
  const pm = new THREE.PMREMGenerator(renderer); const s = new THREE.Scene();
  const room = cnv(4, 256), rg = room.getContext('2d'), rgr = rg.createLinearGradient(0, 0, 0, 256);
  rgr.addColorStop(0, '#3a4250'); rgr.addColorStop(0.5, '#20252e'); rgr.addColorStop(1, '#15181e'); rg.fillStyle = rgr; rg.fillRect(0, 0, 4, 256);
  s.add(new THREE.Mesh(new THREE.SphereGeometry(9, 32, 16), new THREE.MeshBasicMaterial({ map: new THREE.CanvasTexture(room), side: THREE.BackSide })));
  const soft = (() => { const c = cnv(128, 128), g = c.getContext('2d'); const gr = g.createRadialGradient(64, 64, 6, 64, 64, 72); gr.addColorStop(0, '#fff'); gr.addColorStop(0.55, '#ececec'); gr.addColorStop(1, '#000'); g.fillStyle = gr; g.fillRect(0, 0, 128, 128); return new THREE.CanvasTexture(c); })();
  const win = (() => { const c = cnv(256, 256), g = c.getContext('2d'); g.fillStyle = '#000'; g.fillRect(0, 0, 256, 256); g.fillStyle = '#fff'; [[12, 12], [134, 12], [12, 134], [134, 134]].forEach(([x, y]) => g.fillRect(x, y, 110, 110)); return new THREE.CanvasTexture(c); })();
  const add = (w, h, tex, hex, k, x, y, z) => {
    const m = new THREE.Mesh(new THREE.PlaneGeometry(w, h), new THREE.MeshBasicMaterial({ map: tex, color: hex, side: THREE.DoubleSide }));
    m.material.color.multiplyScalar(k); m.position.set(x, y, z); m.lookAt(0, 0, 0); s.add(m);
  };
  add(6.0, 4.5, soft, 0xffffff, 4.5, -4.2, 4.0, 4.2);    // big key softbox, upper left front
  add(3.0, 4.0, win, 0xf2f6ff, 3.6, 5.4, 1.6, 1.8);      // window on the right (reflects on the glossy cap)
  add(4.0, 4.0, soft, 0xffffff, 2.2, 0.4, 6.4, -0.4);    // overhead light
  add(1.4, 7.0, soft, 0xC4DAF3, 2.6, -5.6, 0.4, -2.2);   // cool rim strip, back left
  add(1.4, 7.0, soft, 0xffffff, 2.0, 4.8, 0.2, -3.8);    // rim strip, back right
  add(8.0, 3.0, soft, 0xdcdcdc, 0.18, 0, -5.4, 2.4);     // faint floor bounce
  const tex = pm.fromScene(s, 0.012).texture; pm.dispose(); return tex;
}

/* lathe with hand-molded irregularity; UVs: u around, v along the profile */
function latheGeo(prof, seg, shape) {
  const pts = prof.map(p => new THREE.Vector2(p[0], p[1]));
  const geo = new THREE.LatheGeometry(pts, seg, 0, Math.PI * 2);
  const pos = geo.attributes.position, np = pts.length;
  if (shape) {
    for (let i = 0; i <= seg; i++) {
      const th = (i / seg) * Math.PI * 2;
      for (let j = 0; j < np; j++) {
        const k = i * np + j, y = pos.getY(k), r0 = Math.hypot(pos.getX(k), pos.getZ(k));
        const d = shape(th, y, r0); if (d === 1) continue;
        pos.setX(k, pos.getX(k) * d); pos.setZ(k, pos.getZ(k) * d);
      }
    }
  }
  geo.computeVertexNormals();
  const nrm = geo.attributes.normal;
  for (let j = 0; j < np; j++) {
    const a = j, b = seg * np + j;
    const x = (nrm.getX(a) + nrm.getX(b)) / 2, y = (nrm.getY(a) + nrm.getY(b)) / 2, z = (nrm.getZ(a) + nrm.getZ(b)) / 2;
    const l = Math.hypot(x, y, z) || 1;
    nrm.setXYZ(a, x / l, y / l, z / l); nrm.setXYZ(b, x / l, y / l, z / l);
  }
  return geo;
}
function bodyShape(th, y, r) {
  if (y > 0.58 || y < -1.07) return 1;
  const w = Math.min(1, (0.58 - y) / 0.1) * Math.min(1, (y + 1.07) / 0.08);
  const wobble = 0.005 * Math.sin(2 * th + 0.6) * Math.cos(y * 2.2) - 0.012 * Math.exp(-Math.pow((th - 3.7) / 0.45, 2)) * Math.exp(-Math.pow((y + 0.45) / 0.35, 2))
    - 0.006 * Math.exp(-Math.pow((th - 4.1) / 0.35, 2)) * Math.exp(-Math.pow((y + 0.05) / 0.06, 2));
  return 1 + w * wobble;
}

/* builds geometry + materials for one renderer */
function makePooterKit(renderer) {
  const T = POOTER_TEX, aniso = Math.min(8, renderer.capabilities.getMaxAnisotropy());
  const tex = (c, srgb, rep) => { const t = new THREE.CanvasTexture(c); t.anisotropy = aniso; if (srgb) t.encoding = THREE.sRGBEncoding; if (rep) { t.wrapS = THREE.RepeatWrapping; } return t; };
  const bodyGeo = latheGeo(PROFILE.slice(PROFILE.outerStart, PROFILE.capStart + 1), 180, bodyShape);
  const capGeo = latheGeo(PROFILE.slice(PROFILE.capStart), 180, null);
  const bottomR = PROFILE[PROFILE.outerStart][0];
  const bottomGeo = new THREE.CircleGeometry(bottomR, 128);
  const bodyMat = new THREE.MeshPhysicalMaterial({
    color: new THREE.Color(2.3, 2.3, 2.4), map: tex(T.bodyColor, true, true), roughness: 0.78, roughnessMap: tex(T.bodyRough, false, true),
    normalMap: tex(T.bodyNormal, false, true), normalScale: new THREE.Vector2(0.9, 0.9), sheen: new THREE.Color(0x2a2d33),
    metalness: 0, clearcoat: 0.3, clearcoatRoughness: 0.42, envMapIntensity: 1.5, side: THREE.DoubleSide
  });
  const capMat = new THREE.MeshPhysicalMaterial({
    color: new THREE.Color(1.8, 1.8, 1.85), map: tex(T.capColor, true, true), roughness: 1, roughnessMap: tex(T.capRough, false, true),
    normalMap: tex(T.capNormal, false, true), normalScale: new THREE.Vector2(0.6, 0.6),
    metalness: 0, clearcoat: 1.0, clearcoatRoughness: 0.14, envMapIntensity: 1.3, side: THREE.DoubleSide
  });
  const bottomMat = new THREE.MeshPhysicalMaterial({
    color: new THREE.Color(1.9, 1.9, 1.95), map: tex(T.bottomColor, true), roughness: 1, roughnessMap: tex(T.bottomRough),
    normalMap: tex(T.bottomNormal), normalScale: new THREE.Vector2(1.6, 1.6),
    metalness: 0, clearcoat: 0.05, clearcoatRoughness: 0.7, envMapIntensity: 1.0
  });
  const holeGeo = new THREE.CircleGeometry(0.142, 40);
  const holeMat = new THREE.MeshBasicMaterial({ color: 0x000000 });
  function build() {
    const g = new THREE.Group();
    const body = new THREE.Mesh(bodyGeo, bodyMat);
    const cap = new THREE.Mesh(capGeo, capMat);
    const bottom = new THREE.Mesh(bottomGeo, bottomMat); bottom.rotation.x = Math.PI / 2; bottom.position.y = -H;
    const hole = new THREE.Mesh(holeGeo, holeMat); hole.rotation.x = -Math.PI / 2; hole.position.y = 0.64;
    g.add(body, cap, bottom, hole);
    return { group: g, parts: [body, cap, bottom] };
  }
  return { build };
}

function createStage(canvas, cfg) {
  let renderer;
  try { renderer = new THREE.WebGLRenderer({ canvas, antialias: true, alpha: true, powerPreference: 'high-performance' }); }
  catch (e) { return null; }
  if (!renderer.getContext()) return null;
  renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
  renderer.outputEncoding = THREE.sRGBEncoding;
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1.0;
  renderer.setClearColor(0x000000, 0);

  const FLOOR = cfg.floorY == null ? -H - 0.02 : cfg.floorY;
  const scene = new THREE.Scene();
  scene.environment = makeEnv(renderer);
  const camera = new THREE.PerspectiveCamera(30, 1, 0.1, 100);
  const key = new THREE.DirectionalLight(0xffffff, 0.9); key.position.set(-3, 6, 4); scene.add(key);
  const rim = new THREE.DirectionalLight(0xC4DAF3, 0.9); rim.position.set(4, 2.5, -3.5); scene.add(rim);
  scene.add(new THREE.HemisphereLight(0xeaf2ff, 0x0e1117, 0.18));

  const spin = new THREE.Group(); scene.add(spin);
  const floor = new THREE.Group(); scene.add(floor);
  const shadowParent = cfg.shadowFollows ? spin : floor;
  const homeQ = new THREE.Quaternion().setFromEuler(new THREE.Euler(cfg.initX || 0, cfg.initY || 0, cfg.initZ || 0, 'XYZ'));
  spin.quaternion.copy(homeQ);

  const kit = makePooterKit(renderer);
  const ringGeo = new THREE.TorusGeometry(0.34, 0.022, 10, 72);
  const planeGeo = new THREE.PlaneGeometry(1, 1);
  const shadowMat = new THREE.MeshBasicMaterial({ map: new THREE.CanvasTexture(SHADOW_CANVAS), transparent: true, depthWrite: false, toneMapped: false });

  const pooters = [];
  const qTmp = new THREE.Quaternion(), axis = new THREE.Vector3(), YAX = new THREE.Vector3(0, 1, 0);
  const st = {
    canvas, renderer, scene, camera, spin, pooters, visible: false,
    vx: 0, vy: 0, idle: 10, dragging: false, resetting: false,
    camDist: 8, camDistT: 8, cfg
  };
  function rotateBy(dx, dy) {
    const ang = Math.hypot(dx, dy) * 0.0095; if (ang < 1e-5) return;
    axis.set(dy, dx, 0).normalize().applyQuaternion(camera.quaternion);
    qTmp.setFromAxisAngle(axis, ang); spin.quaternion.premultiply(qTmp);
  }
  st.reset = () => { st.resetting = true; st.vx = st.vy = 0; st.idle = 0; };

  function addPooter(o) {
    const holder = new THREE.Group();
    const tilt = new THREE.Group(); tilt.rotation.set(o.tx || 0, o.ty || 0, o.tz || 0); holder.add(tilt);
    const squish = new THREE.Group(); squish.position.y = -H; tilt.add(squish);
    const built = kit.build(); built.group.position.y = H; squish.add(built.group);
    const [body, cap, bottom] = built.parts;
    const rings = new THREE.Group(); rings.position.y = H + 0.02; tilt.add(rings);
    const shadow = new THREE.Mesh(planeGeo, shadowMat.clone()); shadow.rotation.x = -Math.PI / 2; shadow.position.y = FLOOR; shadowParent.add(shadow);
    holder.userData = {
      tilt, squish, body, cap, bottom, rings, shadow, idx: o.idx || 0, lift: o.lift || 0,
      s: 0, sv: 0, target: 0, y: o.drop ? 3.6 : 0, yv: 0, sc: o.drop ? 0.001 : 1, scT: 1,
      base: new THREE.Vector3(o.x || 0, 0, o.z || 0), baseT: new THREE.Vector3(o.x || 0, 0, o.z || 0),
      emit: false, ringAcc: 0, bob: o.bob || 0, phase: Math.random() * 6
    };
    body.userData.holder = holder; cap.userData.holder = holder; bottom.userData.holder = holder;
    spin.add(holder); pooters.push(holder);
    return holder;
  }
  function removePooter(h) {
    spin.remove(h); shadowParent.remove(h.userData.shadow); h.userData.shadow.material.dispose();
    const i = pooters.indexOf(h); if (i >= 0) pooters.splice(i, 1);
  }
  function emitRing(h) {
    const u = h.userData;
    const m = new THREE.Mesh(ringGeo, new THREE.MeshBasicMaterial({ color: (u.ringN = (u.ringN || 0) + 1) % 2 ? 0xFFD23F : 0x5987D0, transparent: true, opacity: 0.9, depthWrite: false, toneMapped: false }));
    m.rotation.x = Math.PI / 2; m.userData.t = 0; u.rings.add(m);
  }
  function fit() {
    const tanV = Math.tan(THREE.MathUtils.degToRad(camera.fov / 2)), tanH = tanV * camera.aspect;
    const e = cfg.extent ? cfg.extent() : { halfW: cfg.halfW, halfH: cfg.halfH, depth: 0 };
    st.camDistT = Math.max(e.halfH / tanV, e.halfW / tanH) + (e.depth || 0);
  }
  function resize() {
    const r = canvas.getBoundingClientRect(); const w = Math.max(1, r.width), h = Math.max(1, r.height);
    renderer.setSize(w, h, false); camera.aspect = w / h; camera.updateProjectionMatrix(); fit();
  }
  const ray = new THREE.Raycaster(), ndc = new THREE.Vector2();
  function pick(e) {
    const r = canvas.getBoundingClientRect();
    ndc.set(((e.clientX - r.left) / r.width) * 2 - 1, -((e.clientY - r.top) / r.height) * 2 + 1);
    ray.setFromCamera(ndc, camera);
    const meshes = []; pooters.forEach(p => { if (p.userData.scT > 0) meshes.push(p.userData.body, p.userData.cap, p.userData.bottom); });
    const hits = ray.intersectObjects(meshes, false);
    return hits.length ? hits[0].object.userData.holder : null;
  }

  function update(dt, t) {
    if (!st.dragging) {
      if (Math.abs(st.vx) + Math.abs(st.vy) > 0.02) { rotateBy(st.vx * dt * 60, st.vy * dt * 60); const k = Math.pow(0.93, dt * 60); st.vx *= k; st.vy *= k; }
      else { st.vx = st.vy = 0; }
      st.idle += dt;
      if (st.resetting) {
        spin.quaternion.slerp(homeQ, 1 - Math.pow(0.86, dt * 60));
        if (spin.quaternion.angleTo(homeQ) < 0.003) { spin.quaternion.copy(homeQ); st.resetting = false; }
      } else if (cfg.autoSpin && st.idle > 2.5 && !RM) {
        qTmp.setFromAxisAngle(YAX, dt * cfg.autoSpin * Math.min(1, (st.idle - 2.5) / 1.5)); spin.quaternion.multiply(qTmp);
      }
    }
    st.camDist += (st.camDistT - st.camDist) * (1 - Math.pow(0.9, dt * 60));
    camera.position.set(0, cfg.lookY + Math.sin(cfg.elev) * st.camDist, Math.cos(cfg.elev) * st.camDist);
    camera.lookAt(0, cfg.lookY, 0);

    for (let i = pooters.length - 1; i >= 0; i--) {
      const h = pooters[i], u = h.userData;
      u.sc += (u.scT - u.sc) * (1 - Math.pow(0.8, dt * 60));
      if (u.scT === 0 && u.sc < 0.03) { removePooter(h); continue; }
      if (u.y > 0 || u.yv !== 0) {
        u.yv -= 26 * dt; u.y += u.yv * dt;
        if (u.y <= 0) {
          u.y = 0;
          if (u.yv < -1.6) { const imp = -u.yv; u.yv = imp * 0.26; u.sv += imp * 1.0; if (cfg.onLand && imp > 4) cfg.onLand(u.idx); }
          else u.yv = 0;
        }
      }
      u.base.lerp(u.baseT, 1 - Math.pow(0.88, dt * 60));
      if (u.clip) {                         // squeeze follows the loudness of the real recording
        const el = (performance.now() - u.clip.t0) / 1000;
        if (el >= u.clip.dur) { u.clip = null; u.target = 0; u.emit = false; u.sv -= 3.5; }
        else {
          const e = u.clip.env ? u.clip.env[Math.min(u.clip.env.length - 1, Math.floor(el * 60))] : 0.8;
          u.target = 0.45 + 0.6 * e; u.emit = e > 0.15;
        }
      }
      u.sv += (u.target - u.s) * 230 * dt; u.sv *= Math.exp(-15 * dt); u.s += u.sv * dt;
      const s = u.s;
      u.squish.scale.set(1 + 0.12 * s, Math.max(0.55, 1 - 0.2 * s), 1 + 0.12 * s);
      const bob = u.bob && !RM ? Math.sin(t * 1.4 + u.phase) * u.bob : 0;
      h.position.set(u.base.x, u.lift + u.y + bob, u.base.z);
      h.scale.setScalar(Math.max(0.001, u.sc));
      const hh = cfg.shadowFollows ? u.y : Math.max(0, bob), ss = ((cfg.shadowSize || 2.3) - Math.min(hh, 3) * 0.3) * u.sc;
      u.shadow.position.set(u.base.x, FLOOR, u.base.z); u.shadow.scale.set(ss, ss, 1);
      u.shadow.material.opacity = Math.max(0.08, (cfg.shadowAlpha || 0.7) - hh * 0.16) * u.sc * (1 + 0.25 * Math.max(0, s));
      if (u.emit) { u.ringAcc += dt; if (u.ringAcc > 0.11) { u.ringAcc = 0; emitRing(h); } }
      for (let j = u.rings.children.length - 1; j >= 0; j--) {
        const r = u.rings.children[j]; r.userData.t += dt / 0.85; const rt = r.userData.t;
        if (rt >= 1) { u.rings.remove(r); r.material.dispose(); continue; }
        const e = 1 - Math.pow(1 - rt, 3);
        r.position.y = e * 1.3; const sc = 0.4 + e * 2.2; r.scale.set(sc, sc, sc); r.material.opacity = (1 - rt) * 0.9;
      }
    }
    renderer.render(scene, camera);
  }

  /* free drag in any direction (full 360°, over the top and underneath);
     a tap or press on the Pooter itself squeezes it (the real Pooter16 recording) */
  let ptr = null, holdTimer = 0;
  function clipSqueeze(h, env, dur) {
    const u = h.userData; u.clip = { env, dur, t0: performance.now() }; u.target = 0.8; u.emit = true; u.ringAcc = 0.2; u.wordOn = true;
  }
  st.clipSqueeze = clipSqueeze;

  canvas.addEventListener('contextmenu', e => e.preventDefault());
  canvas.addEventListener('pointerdown', e => {
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    Sound.ensure();
    const target = pick(e);   // only the Pooter itself, not the empty space around it
    ptr = { id: e.pointerId, x0: e.clientX, y0: e.clientY, x: e.clientX, y: e.clientY, t0: performance.now(), tm: performance.now(), moved: false, target };
    try { canvas.setPointerCapture(e.pointerId); } catch (err) {}
    st.idle = 0; st.vx = st.vy = 0; st.resetting = false;
    clearTimeout(holdTimer);
    holdTimer = setTimeout(() => { if (ptr && !ptr.moved && ptr.target) { ptr.held = true; cfg.onPress && cfg.onPress(ptr.target); } }, 170);
  });
  canvas.addEventListener('pointermove', e => {
    if (!ptr) { if (e.pointerType === 'mouse') canvas.classList.toggle('can-squeeze', !!pick(e)); return; }
    if (e.pointerId !== ptr.id) return;
    const dx = e.clientX - ptr.x, dy = e.clientY - ptr.y; ptr.x = e.clientX; ptr.y = e.clientY;
    if (!ptr.moved && Math.hypot(e.clientX - ptr.x0, e.clientY - ptr.y0) > 6) { ptr.moved = true; clearTimeout(holdTimer); st.dragging = true; canvas.classList.add('dragging'); }
    if (ptr.moved) {
      rotateBy(dx, dy);
      const now = performance.now(), k = 16 / Math.max(8, now - ptr.tm); ptr.tm = now;
      st.vx = dx * Math.min(1, k); st.vy = dy * Math.min(1, k);
      st.idle = 0;
    }
  });
  const end = e => {
    if (!ptr || e.pointerId !== ptr.id) return;
    clearTimeout(holdTimer);
    if (!ptr.held && !ptr.moved && ptr.target && performance.now() - ptr.t0 < 260) cfg.onPress && cfg.onPress(ptr.target);
    if (ptr.moved && performance.now() - ptr.tm > 90) { st.vx = st.vy = 0; }
    st.dragging = false; canvas.classList.remove('dragging');
    ptr = null; st.idle = 0;
  };
  canvas.addEventListener('pointerup', end);
  canvas.addEventListener('pointercancel', end);
  canvas.addEventListener('lostpointercapture', e => { if (ptr && e.pointerId === ptr.id) end(e); });

  if ('ResizeObserver' in window) new ResizeObserver(resize).observe(canvas); else window.addEventListener('resize', resize);
  resize();
  Object.assign(st, { addPooter, removePooter, fit, resize, update, pick });
  return st;
}

/* ---------- fallback when WebGL isn't available: the real product photo ---------- */
function fallback(stageEl, count) {
  stageEl.classList.add('no-webgl');
  let art = stageEl.querySelector('.fallback-art');
  if (!art) { art = document.createElement('div'); art.className = 'fallback-art'; stageEl.appendChild(art); }
  const one = PHOTO ? `<img src="${PHOTO}" alt="The Original Pooter" width="320" height="320">` : pooterIcon();
  art.innerHTML = count > 1 ? `<div class="fb-row">${Array.from({ length: count }, () => pooterIcon()).join('')}</div>` : one;
}

/* ---------- hero stage ---------- */
const heroStageEl = $('#heroStage'), heroReadout = $('#heroReadout'), squishWord = $('#squishWord');
const READ_IDLE = heroReadout.innerHTML;
let hero = null;
if (HAS3D) try {
  hero = createStage($('#heroCanvas'), {
    single: true, autoSpin: 0.35, elev: 0.14, lookY: -0.1, halfW: 1.7, halfH: 1.9,
    initX: 0.24, initY: 0.55, floorY: -1.7, shadowSize: 2.8, shadowAlpha: 0.5,
    onPress() { squeezeToot(); }
  });
  if (hero) hero.addPooter({ bob: 0.05, drop: !RM, idx: 0 });
} catch (err) { console.error(err); hero = null; }
if (!hero) fallback(heroStageEl, 1);

$('#hearIt').addEventListener('click', () => { Sound.ensure(); squeezeToot(); });

/* squeeze button and the 3D Pooter: play a random recording all the way through, with a countdown
   on the button until it's ready again (keyboard friendly) */
const sqBtn = $('#squeezeBtn'), sqLabel = $('#sqLabel'), SQ_IDLE = sqLabel.textContent;
let sqCool = false, sqTimer = 0;
function sqNudge() { sqBtn.classList.remove('nudge'); void sqBtn.offsetWidth; sqBtn.classList.add('nudge'); }
async function squeezeToot() {
  if (sqCool) { sqNudge(); return; }
  sqCool = true;
  sqBtn.classList.add('cooling'); sqBtn.setAttribute('aria-disabled', 'true'); sqBtn.style.setProperty('--p', 1);
  heroStageEl.classList.add('tooting');
  const cl = await Sound.squeezeAny();
  const dur = cl ? cl.dur : 1.6, t0 = performance.now();
  if (hero && hero.pooters[0]) { hero.idle = 0; hero.clipSqueeze(hero.pooters[0], cl ? cl.env : null, dur); }
  const tick = () => {
    if (!sqCool) return;
    const left = Math.max(0, dur - (performance.now() - t0) / 1000);
    sqBtn.style.setProperty('--p', (left / dur).toFixed(3));
    sqLabel.textContent = `Tooting… ${left.toFixed(1)}s`;
    heroReadout.innerHTML = `<span class="live"></span>Squeezing · ready again in ${left.toFixed(1)}s`;
    if (left > 0) requestAnimationFrame(tick);
  };
  requestAnimationFrame(tick);
  clearTimeout(sqTimer);
  sqTimer = setTimeout(() => {
    sqCool = false;
    sqBtn.classList.remove('cooling'); sqBtn.removeAttribute('aria-disabled'); sqBtn.style.removeProperty('--p');
    sqLabel.textContent = SQ_IDLE; heroReadout.innerHTML = READ_IDLE; heroStageEl.classList.remove('tooting');
    sqBtn.classList.add('ready'); setTimeout(() => sqBtn.classList.remove('ready'), 500);
  }, dur * 1000 + 60);
}
const sqDown = () => { sqBtn.classList.add('held'); Sound.ensure(); squeezeToot(); };
const sqUp = () => sqBtn.classList.remove('held');
sqBtn.addEventListener('pointerdown', e => { if (e.pointerType === 'mouse' && e.button !== 0) return; e.preventDefault(); sqDown(); });
sqBtn.addEventListener('pointerup', sqUp);
sqBtn.addEventListener('pointercancel', sqUp);
sqBtn.addEventListener('pointerleave', sqUp);
sqBtn.addEventListener('contextmenu', e => e.preventDefault());
sqBtn.addEventListener('keydown', e => { if ((e.key === ' ' || e.key === 'Enter') && !e.repeat) { e.preventDefault(); sqDown(); } });
sqBtn.addEventListener('keyup', e => { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); sqUp(); } });
sqBtn.addEventListener('blur', sqUp);
// keep the button from changing width while the countdown runs
(document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve()).then(() => { sqLabel.style.minWidth = sqLabel.offsetWidth + 'px'; });

/* ---------- product photo gallery (shop) ---------- */
(function gallery() {
  const track = $('#gTrack'); if (!track || !$('#gPrev')) return;
  const slides = $$('.g-slide', track), thumbs = $$('.g-thumb'), prev = $('#gPrev'), next = $('#gNext'), count = $('#gCount');
  let cur = 0;
  const go = i => { i = clamp(i, 0, slides.length - 1); track.scrollTo({ left: slides[i].offsetLeft, behavior: RM ? 'auto' : 'smooth' }); };
  const sync = i => {
    cur = i; count.textContent = `${i + 1} / ${slides.length}`;
    thumbs.forEach((t, k) => { t.classList.toggle('on', k === i); t.setAttribute('aria-selected', String(k === i)); });
    prev.disabled = i === 0; next.disabled = i === slides.length - 1;
  };
  let raf = 0;
  track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => sync(Math.round(track.scrollLeft / Math.max(1, track.clientWidth)))); });
  thumbs.forEach(t => t.addEventListener('click', () => go(+t.dataset.i)));
  prev.addEventListener('click', () => go(cur - 1));
  next.addEventListener('click', () => go(cur + 1));
  track.addEventListener('keydown', e => { if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); } });
  sync(0);
})();
$$('[data-reset]').forEach(b => b.addEventListener('click', () => { if (hero) hero.reset(); }));

/* ---------- render loop (visible stages only) ---------- */
const stages = [hero].filter(Boolean);
if ('IntersectionObserver' in window) {
  const io = new IntersectionObserver(es => es.forEach(en => { const s = stages.find(x => x.canvas === en.target); if (s) s.visible = en.isIntersecting; }), { rootMargin: '80px' });
  stages.forEach(s => io.observe(s.canvas));
} else stages.forEach(s => { s.visible = true; });

const puffDots = $$('#puff circle').map(c => ({ el: c, cy: +c.getAttribute('cy'), r: +c.getAttribute('r'), cx: +c.getAttribute('cx') }));
let puffLvl = 0, puffOn = false;
let last = performance.now();
function frame(now) {
  const dt = Math.min(0.05, (now - last) / 1000); last = now; const t = now / 1000;
  if (!document.hidden && !document.documentElement.classList.contains('pp-open')) {   // the game has the screen
    stages.forEach(s => {
      if (!s.visible || s.broken) return;
      try { s.update(dt, t); } catch (err) { console.error(err); s.broken = true; fallback(s.canvas.parentElement, 1); }
    });
    const lvl = Sound.ready ? Sound.level() : 0;
    puffLvl += (Math.min(1, lvl * 5) - puffLvl) * 0.25;
    if (puffLvl > 0.002 || puffOn) {
      puffDots.forEach((d, i) => {
        const up = puffLvl * (10 + i * 9), grow = 1 + puffLvl * (0.5 + i * 0.25);
        d.el.setAttribute('cy', (d.cy - up).toFixed(2)); d.el.setAttribute('cx', (d.cx + puffLvl * i * 4).toFixed(2)); d.el.setAttribute('r', (d.r * grow).toFixed(2));
      });
      puffOn = puffLvl > 0.002;
    }
    // the word "squeeze" only moves while the Pooter is being pressed (transform only, so nothing on the page shifts)
    if (hero && hero.pooters[0]) {
      const u = hero.pooters[0].userData;
      if (u.wordOn) {
        const s = clamp(u.s, -0.3, 1);
        squishWord.style.transform = `scale(${(1 - 0.14 * s).toFixed(3)}, ${(1 + 0.1 * s).toFixed(3)})`;
        if (!u.clip && Math.abs(u.s) < 0.01 && Math.abs(u.sv) < 0.05) { u.wordOn = false; squishWord.style.transform = ''; }
      }
    }
    drawViz(t);
  }
  requestAnimationFrame(frame);
}
requestAnimationFrame(frame);
setTimeout(() => $('#heroTitle').classList.add('settled'), 1500);

/* =========================================================
   SHOP UI + CART
   On farts.com (the Shopify theme) the theme writes the real products
   into the page as window.FARTS_SHOP: variant IDs, prices in cents and
   stock. Add to cart, the cart drawer and checkout then use Shopify's
   own cart (/cart/add.js, /cart.js, /cart/change.js) and its secure
   checkout. No API keys are involved.

   Anywhere else (the offline previews) there is no store: the launch
   prices below are shown and the buy button reads "Coming soon".
   SHOPIFY is a third, unused option: a separately hosted copy talking to
   a store's Storefront API (public token only, never an Admin token).
   ========================================================= */
const THEME = window.FARTS_SHOP && window.FARTS_SHOP.pooter ? window.FARTS_SHOP : null;
const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
const SHOPIFY = null;
/* const SHOPIFY = {
  endpoint: 'https://<new-farts-store>.myshopify.com/api/2026-10/graphql.json',
  token: '<public Storefront access token>',
  pooter: '<Original Pooter handle>',
  wax: '<wax handle>'
}; */
// Launch prices shown while checkout is paused
const LAUNCH_PRICES = { pooter: 11.99, wax: 3.95 };   // one Pooter at a time (no packs): buy more with the quantity
const LIVE = !!(THEME || SHOPIFY);   // a real store is connected
const FREE = (THEME && +THEME.free) || 25;   // display only. The real rule is the store's free-shipping rate (US orders $25+).
const MAX_QTY = 99;
const esc = s => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
let CURRENCY = 'USD';
/* On farts.com prices are shown the way Shopify shows them for the shopper's market (£10.00 in the UK, $11.99 in the US):
   FARTS_SHOP.money_tpl is Shopify's own formatting of 1234.56 in that currency. */
const MONEY_TPL = THEME && typeof THEME.money_tpl === 'string' ? THEME.money_tpl : '';
const MONEY_PARTS = MONEY_TPL.match(/1([^\d]?)234([^\d])56/);
const money = n => {
  if (MONEY_PARTS) {
    const neg = n < 0, [i, f] = Math.abs(n).toFixed(2).split('.');
    return (neg ? '-' : '') + MONEY_TPL.replace(MONEY_PARTS[0], i.replace(/\B(?=(\d{3})+(?!\d))/g, MONEY_PARTS[1]) + MONEY_PARTS[2] + f);
  }
  return CURRENCY === 'USD' ? fmt(n) : new Intl.NumberFormat(undefined, { style: 'currency', currency: CURRENCY }).format(n);
};
/* Free shipping is a US offer in US dollars. Outside the US (or in another currency) there is no progress bar, just the rule. */
const FREE_HERE = () => !THEME || ((THEME.country || 'US') === 'US' && CURRENCY === 'USD');
const FREE_ELSEWHERE = 'Shipping is calculated at checkout. Free shipping is for US orders of US$' + FREE + '+.';

async function shopify(query, variables) {
  if (!SHOPIFY) throw new Error('No store is connected yet');
  const ctl = new AbortController(), timer = setTimeout(() => ctl.abort(), 15000);
  try {
    const res = await fetch(SHOPIFY.endpoint, {
      method: 'POST', credentials: 'omit', signal: ctl.signal,
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Shopify-Storefront-Access-Token': SHOPIFY.token },
      body: JSON.stringify({ query, variables: variables || {} })
    });
    if (!res.ok) throw new Error('The store returned ' + res.status);
    const json = await res.json();
    if (json.errors && json.errors.length) throw new Error(json.errors[0].message || 'The store returned an error');
    return json.data;
  } finally { clearTimeout(timer); }
}

/* ---------- product picker: the Original Pooter in any quantity, plus optional wax ---------- */
const Q_PRODUCTS = () => `query FartsProducts { pooter: product(handle: "${SHOPIFY.pooter}") { ...P } wax: product(handle: "${SHOPIFY.wax}") { ...P } }
fragment P on Product { handle title availableForSale variants(first: 1) { nodes { id availableForSale price { amount currencyCode } compareAtPrice { amount currencyCode } } } }`;
let POOTER = null, WAX = null;   // { id, price, compare, available }
let catalog = 'loading';   // 'loading' | 'ready' | 'error'
let catalogAt = 0;
const state = { wax: 0, qty: 1 };   // Pooters (1+) and Pooter Wax (0+)
const MAX_EACH = 20;
let adding = false;

function toItem(p) {
  const v = p && p.variants && p.variants.nodes[0];
  if (!v) return null;
  const price = parseFloat(v.price.amount), compare = v.compareAtPrice ? parseFloat(v.compareAtPrice.amount) : null;
  if (!isFinite(price)) return null;
  return { id: v.id, price, compare: compare != null && compare > price ? compare : null, available: !!(p.availableForSale && v.availableForSale), currency: v.price.currencyCode };
}

function shipMsg(total, textEl, barEl) {
  barEl.hidden = !FREE_HERE();
  if (!FREE_HERE()) { textEl.textContent = FREE_ELSEWHERE; return; }
  const pct = clamp(total / FREE, 0, 1);
  barEl.querySelector('i').style.width = (pct * 100).toFixed(1) + '%';
  barEl.classList.toggle('full', pct >= 1);
  textEl.innerHTML = total >= FREE ? '<b>Free US shipping</b> unlocked.' : `Add <b>${money(FREE - total)}</b> more for free US shipping.`;
}
function shipIdle(textEl, barEl) {
  barEl.querySelector('i').style.width = '0%'; barEl.classList.remove('full');
  barEl.hidden = !FREE_HERE();
  textEl.textContent = FREE_HERE() ? 'Free US shipping on orders $' + FREE + '+' : FREE_ELSEWHERE;
}
function updateBuy() {
  const buy = $('#buy'), P = POOTER, add = $('#addBtn');
  buy.classList.toggle('loading', catalog === 'loading');
  buy.classList.toggle('failed', catalog === 'error');
  $('.price-row', buy).setAttribute('aria-busy', catalog === 'loading' ? 'true' : 'false');
  $('#shopNote').hidden = catalog !== 'error';
  $('#qtyVal').textContent = state.qty; $('#waxVal').textContent = state.wax;
  $('#qtyMinus').disabled = state.qty <= 1; $('#qtyPlus').disabled = state.qty >= MAX_EACH;
  if (catalog !== 'ready' || !P) {
    $('#price').innerHTML = '&nbsp;'; $('#was').hidden = true; $('#save').hidden = true;
    $('#perEach').textContent = catalog === 'error' ? '' : 'Getting live prices…';
    $('#waxPrice').innerHTML = '&nbsp;';
    add.textContent = 'Add to cart'; add.disabled = true;
    shipIdle($('#shipText'), $('#shipBar'));
    return;
  }
  const waxOk = !!(WAX && WAX.available);
  if (!waxOk) state.wax = 0;
  $('#waxVal').textContent = state.wax;
  $('#waxMinus').disabled = !waxOk || state.wax <= 0; $('#waxPlus').disabled = !waxOk || state.wax >= MAX_EACH;
  $('#waxRow').classList.toggle('on', state.wax > 0);
  $('#waxPrice').textContent = !WAX ? 'Unavailable' : !WAX.available ? 'Sold out' : money(WAX.price) + ' each';
  const extra = waxOk ? cents(WAX.price) * state.wax : 0;
  const total = (cents(P.price) * state.qty + extra) / 100;
  $('#price').textContent = money(total);
  const hasCompare = P.compare != null;   // only if the store ever sets a compare-at price
  const was = hasCompare ? (cents(P.compare) * state.qty + extra) / 100 : 0;
  $('#was').textContent = money(was); $('#was').hidden = !hasCompare;
  $('#save').textContent = 'Save ' + money(was - total); $('#save').hidden = !hasCompare;
  $('#perEach').textContent = (state.qty === 1 ? `One Original Pooter · ${money(P.price)}` : `${state.qty} Pooters · ${money(P.price)} each`)
    + (state.wax ? ` + ${state.wax} Pooter Wax` : '');
  add.disabled = !LIVE || !P.available || adding;
  add.textContent = !LIVE ? 'Coming soon' : !P.available ? 'Sold out' : adding ? 'Adding…' : `Add to cart · ${money(total)}`;
  add.classList.toggle('soon', !LIVE);
  $('#launchNote').hidden = LIVE;
  shipMsg(total, $('#shipText'), $('#shipBar'));
}
function updateBuyBar() {
  $('#buyBarFrom').textContent = catalog === 'ready' && POOTER && POOTER.available ? money(POOTER.price) + ' each' : 'By Jack Vale';
  const tag = $('.shop-price');   // the "$11.99 each" tag by the shop headline, in the shopper's currency
  if (tag && THEME && catalog === 'ready' && POOTER) tag.textContent = money(POOTER.price) + ' each';
}
function launchCatalog() {
  POOTER = { id: null, price: LAUNCH_PRICES.pooter, compare: null, available: true, currency: 'USD' };
  WAX = { id: null, price: LAUNCH_PRICES.wax, compare: null, available: true, currency: 'USD' };
  CURRENCY = 'USD'; catalog = 'ready'; catalogAt = Date.now();
}
function themeCatalog() {
  const item = p => p ? { id: p.variant_id, price: p.price / 100, compare: p.compare_at_price > p.price ? p.compare_at_price / 100 : null, available: !!p.available, currency: THEME.currency || 'USD' } : null;
  POOTER = item(THEME.pooter); WAX = item(THEME.wax);
  CURRENCY = THEME.currency || 'USD'; catalog = 'ready'; catalogAt = Date.now();
}
async function loadCatalog() {
  if (THEME) { themeCatalog(); updateBuy(); updateBuyBar(); return; }
  if (!SHOPIFY) { launchCatalog(); updateBuy(); updateBuyBar(); return; }
  catalog = 'loading'; updateBuy();
  try {
    const d = await shopify(Q_PRODUCTS());
    POOTER = toItem(d.pooter); WAX = toItem(d.wax);
    if (!POOTER) throw new Error('No product came back');
    CURRENCY = POOTER.currency || 'USD';
    catalog = 'ready'; catalogAt = Date.now();
  } catch (e) { catalog = 'error'; }
  updateBuy(); updateBuyBar();
}
$('#retryPrices').addEventListener('click', loadCatalog);
$('#waxMinus').addEventListener('click', () => { state.wax = Math.max(0, state.wax - 1); updateBuy(); });
$('#waxPlus').addEventListener('click', () => { state.wax = Math.min(MAX_EACH, state.wax + 1); updateBuy(); });
$('#qtyMinus').addEventListener('click', () => { state.qty = Math.max(1, state.qty - 1); updateBuy(); });
$('#qtyPlus').addEventListener('click', () => { state.qty = Math.min(MAX_EACH, state.qty + 1); updateBuy(); });

/* ---------- cart (lives in Shopify; only its id is kept in this browser) ---------- */
const CART_KEY = 'fc-shopify-cart';
const CART_FIELDS = `fragment C on Cart { id checkoutUrl totalQuantity cost { subtotalAmount { amount currencyCode } totalAmount { amount currencyCode } } lines(first: 50) { nodes { id quantity cost { totalAmount { amount currencyCode } } merchandise { ... on ProductVariant { id product { handle title } } } } } }`;
const RESULT = `{ cart { ...C } userErrors { code field message } warnings { code message } }`;
const GQL = {
  get: `${CART_FIELDS} query FartsCart($id: ID!) { cart(id: $id) { ...C } }`,
  create: `${CART_FIELDS} mutation FartsCartCreate($lines: [CartLineInput!]!) { cartCreate(input: { lines: $lines }) ${RESULT} }`,
  add: `${CART_FIELDS} mutation FartsCartAdd($id: ID!, $lines: [CartLineInput!]!) { cartLinesAdd(cartId: $id, lines: $lines) ${RESULT} }`,
  update: `${CART_FIELDS} mutation FartsCartUpdate($id: ID!, $lines: [CartLineUpdateInput!]!) { cartLinesUpdate(cartId: $id, lines: $lines) ${RESULT} }`,
  remove: `${CART_FIELDS} mutation FartsCartRemove($id: ID!, $lineIds: [ID!]!) { cartLinesRemove(cartId: $id, lineIds: $lineIds) ${RESULT} }`
};
const HANDLES = THEME ? { pooter: THEME.pooter.handle, wax: THEME.wax && THEME.wax.handle } : SHOPIFY ? { pooter: SHOPIFY.pooter, wax: SHOPIFY.wax } : {};
const HANDLE_PACK = {}; if (HANDLES.pooter) HANDLE_PACK[HANDLES.pooter] = 1;
let cartData = null, cartLines = [], cartBusy = 0, cartQueue = Promise.resolve();
const cartCount = $('#cartCount'), drawer = $('#drawer'), scrim = $('#scrim');
try { localStorage.removeItem('fc-cart-v2'); } catch (e) {}   // a cart key from an early test version
if (!SHOPIFY) { try { localStorage.removeItem(CART_KEY); } catch (e) {} }   // the Storefront-API cart id isn't used by the theme
if (!LIVE) $('#cartBtn').style.display = 'none';   // no store: no cart

/* Shopify's own cart (theme mode). /cart.js answers in cents; it is turned into the same shape the
   drawer already draws, so the drawer code is shared. */
async function ajax(path, body) {
  const res = await fetch(ROOT + path, body
    ? { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }
    : { credentials: 'same-origin', headers: { 'Accept': 'application/json' } });
  let json = null; try { json = await res.json(); } catch (e) {}
  if (!res.ok) throw Object.assign(new Error((json && (json.description || json.message)) || 'The store returned ' + res.status), { friendly: !!(json && json.description) });
  return json;
}
const fromAjax = c => !c ? null : {
  id: c.token || 'cart', checkoutUrl: ROOT + 'checkout', totalQuantity: c.item_count,
  cost: { subtotalAmount: { amount: c.total_price / 100 }, totalAmount: { amount: c.total_price / 100 } },
  lines: { nodes: (c.items || []).map(it => ({ id: it.key, quantity: it.quantity, cost: { totalAmount: { amount: it.final_line_price / 100 } },
    merchandise: { id: it.variant_id, product: { handle: it.handle, title: it.product_title } } })).reverse() }   // drawn in a fixed order anyway
};

function setCart(c) {
  cartData = c && c.lines ? c : null;
  if (SHOPIFY) { if (cartData) store.set(CART_KEY, cartData.id); else { try { localStorage.removeItem(CART_KEY); } catch (e) {} } }
  renderCart();
}
function setBusy(on) {
  cartBusy = Math.max(0, cartBusy + (on ? 1 : -1));
  drawer.classList.toggle('busy', cartBusy > 0); drawer.setAttribute('aria-busy', cartBusy > 0 ? 'true' : 'false');
  $('#checkout').disabled = cartBusy > 0 || !(cartData && cartData.totalQuantity > 0);
}
function cartOp(fn) {
  const run = cartQueue.then(async () => { setBusy(true); try { return await fn(); } finally { setBusy(false); } });
  cartQueue = run.catch(() => {});
  return run;
}
// Shopify answers a call on a cart that no longer exists with a fresh cart plus a "cartId" error.
const expired = out => (out.userErrors || []).some(e => (e.field || []).includes('cartId'));
const notice = out => { const n = (out.userErrors || []).filter(e => !(e.field || []).includes('cartId'))[0] || (out.warnings || [])[0]; return n ? n.message : ''; };
const cartAdd = lines => cartOp(async () => {
  if (THEME) {
    await ajax('cart/add.js', { items: lines.map(l => ({ id: l.merchandiseId, quantity: l.quantity })) });
    setCart(fromAjax(await ajax('cart.js')));
    return '';
  }
  let out = cartData ? (await shopify(GQL.add, { id: cartData.id, lines })).cartLinesAdd : null;
  if (!out || !out.cart) out = (await shopify(GQL.create, { lines })).cartCreate;   // no cart yet (an expired one is replaced by Shopify itself)
  if (!out.cart) throw Object.assign(new Error(notice(out) || 'That could not be added to your cart.'), { friendly: true });
  setCart(out.cart);
  return notice(out);
});
const cartSetQty = (lineId, qty) => cartOp(async () => {
  if (!cartData) return '';
  if (THEME) { setCart(fromAjax(await ajax('cart/change.js', { id: lineId, quantity: Math.max(0, Math.min(MAX_QTY, qty)) }))); return ''; }
  const out = qty > 0
    ? (await shopify(GQL.update, { id: cartData.id, lines: [{ id: lineId, quantity: Math.min(MAX_QTY, qty) }] })).cartLinesUpdate
    : (await shopify(GQL.remove, { id: cartData.id, lineIds: [lineId] })).cartLinesRemove;
  if (!out.cart || expired(out)) { setCart(null); return 'Your cart expired. Please add your items again.'; }
  setCart(out.cart);
  return notice(out);
});
const cartRefresh = () => !LIVE ? Promise.resolve() : THEME ? cartOp(async () => { setCart(fromAjax(await ajax('cart.js'))); }) : cartOp(async () => {
  const id = store.get(CART_KEY, null);
  if (typeof id !== 'string' || !id) { setCart(null); return; }
  setCart((await shopify(GQL.get, { id })).cart);   // null when the cart was checked out or has expired
});

function lineInfo(product) {
  const n = HANDLE_PACK[product.handle];
  if (HANDLES.wax && product.handle === HANDLES.wax) return { name: 'Pooter Wax', variant: 'For deeper fart sounds', wax: true };
  if (n) return { name: 'The Original Pooter', variant: 'Black' };
  return { name: esc(product.title), variant: '' };
}
function renderCart() {
  // Shopify lists the newest line first; show Pooters by pack size, then wax, so the order never jumps around
  const rank = l => HANDLE_PACK[l.merchandise.product.handle] || (HANDLES.wax && l.merchandise.product.handle === HANDLES.wax ? 50 : 99);
  cartLines = cartData ? cartData.lines.nodes.filter(l => l.merchandise && l.merchandise.product).sort((a, b) => rank(a) - rank(b)) : [];
  const count = cartData ? cartData.totalQuantity : 0;
  cartCount.textContent = count;
  $('#cartBtn').classList.toggle('has', count > 0);
  $('#cartBtn').setAttribute('aria-label', count ? `Open cart, ${count} item${count === 1 ? '' : 's'}` : 'Open cart');
  const list = $('#cartList');
  list.innerHTML = cartLines.map((l, i) => {
    const info = lineInfo(l.merchandise.product);
    const thumb = info.wax && THEME && THEME.wax_pic
      ? `<img src="${THEME.wax_pic}" alt="" width="64" height="64">`
      : info.wax
      ? `<svg viewBox="0 0 80 80" aria-hidden="true"><rect x="20" y="30" width="40" height="32" rx="9" fill="#FFD23F"/><rect x="16" y="22" width="48" height="13" rx="6.5" fill="#12161F"/></svg>`
      : (PHOTO ? `<img src="${PHOTO}" alt="" width="64" height="64">` : pooterIcon());
    return `<li class="ci" data-i="${i}">
      <div class="ci-thumb">${thumb}</div>
      <div><div class="ci-name">${info.name}</div><div class="ci-var">${info.variant}</div>
        <div class="ci-qty"><button type="button" data-act="dec" aria-label="Decrease ${info.name}"><svg><use href="#i-minus"/></svg></button><span>${l.quantity}</span><button type="button" data-act="inc" aria-label="Increase ${info.name}"><svg><use href="#i-plus"/></svg></button></div>
      </div>
      <div class="ci-price">${money(parseFloat(l.cost.totalAmount.amount))}</div>
    </li>`;
  }).join('');
  $('#cartEmpty').hidden = cartLines.length > 0;
  list.hidden = cartLines.length === 0;
  const sub = cartData ? parseFloat(cartData.cost.subtotalAmount.amount) : 0;
  $('#subtotal').textContent = money(sub);
  $('#checkout').disabled = cartBusy > 0 || count === 0;
  if (count > 0) shipMsg(sub, $('#dShipText'), $('#dShipBar')); else shipIdle($('#dShipText'), $('#dShipBar'));
}
$('#cartList').addEventListener('click', e => {
  const b = e.target.closest('button[data-act]'); if (!b) return;
  const l = cartLines[+b.closest('.ci').dataset.i]; if (!l) return;
  const qty = l.quantity + (b.dataset.act === 'inc' ? 1 : -1);
  if (qty > MAX_QTY) return;
  cartSetQty(l.id, qty).then(msg => { if (msg) toast(msg); }, () => toast('We couldn’t update your cart. Check your connection and try again.'));
});
let cartOpener = null;   // where keyboard focus was before the cart opened, so it can go back there
function openCart(from) {
  const a = from instanceof Element ? from : document.activeElement; cartOpener = a && a !== document.body && !drawer.contains(a) ? a : null;
  drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); drawer.inert = false; scrim.hidden = false;
  setTimeout(() => $('#closeCart').focus(), 50);
}
function closeCart(restore) {
  const wasOpen = drawer.classList.contains('open'), hadFocus = drawer.contains(document.activeElement);
  drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); drawer.inert = true; scrim.hidden = true;
  if (!wasOpen || restore === false || !hadFocus) return;
  const back = [cartOpener, $('#cartBtn'), $('.shop-btn')].find(el => el && el.isConnected && el.getClientRects().length);
  if (back) back.focus({ preventScroll: true });
}
/* keep Tab inside the open cart */
drawer.addEventListener('keydown', e => {
  if (e.key !== 'Tab' || !drawer.classList.contains('open')) return;
  const f = $$('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])', drawer).filter(el => el.getClientRects().length);
  if (!f.length) return;
  const first = f[0], last = f[f.length - 1];
  if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
  else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
});
drawer.inert = true;
$('#cartBtn').addEventListener('click', openCart);
$('#closeCart').addEventListener('click', closeCart);
scrim.addEventListener('click', closeCart);
$('#emptyShop').addEventListener('click', () => closeCart(false));   // it goes on to the shop
document.addEventListener('keydown', e => { if (e.key === 'Escape' && drawer.classList.contains('open')) closeCart(); });

/* checkout: Shopify's own secure checkout, using a freshly requested link */
$('#checkout').addEventListener('click', async () => {
  if (!cartData || !cartData.totalQuantity) return;
  const btn = $('#checkout'), label = btn.textContent;
  btn.textContent = 'Opening checkout…';
  let url = '';
  try {
    await cartRefresh();
    url = cartData && cartData.totalQuantity ? cartData.checkoutUrl : '';
    if (!url) toast('Your cart is empty or has expired. Please add your items again.');
  } catch (e) {
    url = cartData ? cartData.checkoutUrl : '';
    if (!url) toast('We couldn’t reach checkout. Check your connection and try again.');
  }
  btn.textContent = label;
  if (/^https:\/\//.test(url) || (THEME && /^\/[^/]/.test(url))) location.assign(url);
});

$('#addBtn').addEventListener('click', async () => {
  const P = POOTER;
  if (!LIVE || catalog !== 'ready' || !P || !P.available || adding) return;
  Sound.ensure();   // unlock audio inside the tap, so the squeeze can play once Shopify answers
  const lines = [{ merchandiseId: P.id, quantity: state.qty }];
  if (state.wax > 0 && WAX && WAX.available) lines.push({ merchandiseId: WAX.id, quantity: state.wax });
  adding = true; updateBuy();
  try {
    const msg = await cartAdd(lines);
    cartCount.classList.remove('bump'); void cartCount.offsetWidth; cartCount.classList.add('bump');
    Sound.squeeze();   // the real Pooter recording, every time
    openCart($('#addBtn'));   // closing the cart brings focus back to this button
    if (msg) toast(msg);
  } catch (e) {
    toast(e && e.friendly ? e.message : 'We couldn’t add that to your cart. Check your connection and try again.');
    cartRefresh().catch(() => {});
  } finally { adding = false; updateBuy(); }
});

updateBuy(); renderCart();
loadCatalog();
cartRefresh().catch(() => {});
/* coming back from checkout, or to a tab left open: re-sync with Shopify */
window.addEventListener('pageshow', e => { if (e.persisted) { loadCatalog(); cartRefresh().catch(() => {}); } });
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState !== 'visible') return;
  if (Date.now() - catalogAt > 10 * 60 * 1000) loadCatalog();
  cartRefresh().catch(() => {});
});

/* the shop headline's "Pooter." sticker pops in the first time the shop comes into view */
(() => {
  const st = $('#shopSticker');
  if (!st || !('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  st.classList.add('pre');
  const io = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)) { st.classList.remove('pre'); st.classList.add('pop'); io.disconnect(); } }, { threshold: 0.6 });
  io.observe(st);
})();

/* Pooter Wax photo in the wax row (farts.com): tap it for a bigger look */
(() => {
  const pic = $('#waxPic'); if (!pic) return;
  let dlg = null;
  pic.addEventListener('click', () => {
    if (!dlg) {
      dlg = document.createElement('dialog'); dlg.className = 'wax-dlg'; dlg.setAttribute('aria-label', 'Pooter Wax');
      dlg.innerHTML = `<button class="wax-x" type="button" aria-label="Close"><svg aria-hidden="true"><use href="#i-x"/></svg></button>
        <img src="${pic.dataset.big}" alt="Pooter Wax: a tube labeled Pooter Wax, wax for your Pooter" width="1000" height="562">
        <div class="wax-cap"><strong>Pooter Wax</strong><p>Rub a little around your Pooter’s hole, then squeeze as usual for deeper fart sounds.</p></div>`;
      document.body.appendChild(dlg);
      dlg.addEventListener('click', e => { if (e.target === dlg || e.target.closest('.wax-x')) dlg.close(); });
    }
    if (typeof dlg.showModal === 'function') dlg.showModal(); else window.open(pic.dataset.big, '_blank', 'noopener');
  });
})();

/* mobile buy bar */
const buyBar = $('#buyBar');
if ('IntersectionObserver' in window) {
  const seen = { top: true, shop: false };
  const bio = new IntersectionObserver(es => {
    es.forEach(en => { seen[en.target.id] = en.isIntersecting; });
    buyBar.classList.toggle('show', !seen.top && !seen.shop);
  }, { threshold: 0.05 });
  bio.observe($('#top')); bio.observe($('#shop'));
}

/* =========================================================
   TOOT LAB
   ========================================================= */
const LAB = [
  { id: 'finale',   name: 'The Grand Finale',          meta: '1.5 sec' },
  { id: 'surprise', name: 'Surprise Ending',           meta: '0.6 sec' },
  { id: 'straight', name: 'Straight and to the Point', meta: '0.3 sec' },
  { id: 'daddy',    name: 'Daddy Sang Bass',           meta: '0.9 sec' },
  { id: 'getaway',  name: 'The One That Got Away',     meta: '0.5 sec' },
  { id: 'momma',    name: 'Momma Sang Tenor',          meta: '2.0 sec' }
];
const padsEl = $('#pads');
padsEl.innerHTML = LAB.map((p, i) => `
  <button class="pad" type="button" data-i="${i}" aria-label="Play ${p.name}">
    <span class="pad-k"><span>${i + 1}</span><svg aria-hidden="true"><use href="#puff"/></svg></span>
    <span><span class="pad-n">${p.name}</span><span class="pad-m">${p.meta}</span></span>
  </button>`).join('');
let vizTimer = 0, padOn = -1, padTimer = 0, padSeq = 0, labWave = null;
async function playPad(i) {
  const p = LAB[i], seq = ++padSeq;
  if (padOn >= 0) padsEl.children[padOn].classList.remove('on');
  padOn = i; padsEl.children[i].classList.add('on');
  $('#vizName').textContent = p.name; $('#vizMeta').textContent = p.meta;
  if (Sound.muted) toast('Sound is off. Tap the speaker in the header to turn it on.');
  const cl = await Sound.playClip(p.id, 'lab');
  if (seq !== padSeq) return;                       // a newer pad took over
  const d = cl ? cl.dur : 0.6;
  labWave = cl ? { peaks: cl.peaks, dur: cl.dur, t0: performance.now(), shown: '' } : null;
  clearTimeout(padTimer); padTimer = setTimeout(() => { padsEl.children[i].classList.remove('on'); if (padOn === i) padOn = -1; }, Math.max(260, d * 1000));
  clearTimeout(vizTimer); vizTimer = setTimeout(() => { $('#vizMeta').textContent = p.meta; }, d * 1000 + 400);
}
padsEl.addEventListener('click', e => { const b = e.target.closest('.pad'); if (b) playPad(+b.dataset.i); });
$('#randomToot').addEventListener('click', () => playPad(Math.floor(Math.random() * LAB.length)));
document.addEventListener('keydown', e => {
  if (e.metaKey || e.ctrlKey || e.altKey || e.repeat) return;
  const tag = (e.target.tagName || '').toLowerCase(); if (tag === 'input' || tag === 'select' || tag === 'textarea') return;
  const n = parseInt(e.key, 10); if (n >= 1 && n <= LAB.length) playPad(n - 1);
});
$('#copyLab').addEventListener('click', () => {
  const ok = () => toast('Link copied: farts.com/#lab');
  try { navigator.clipboard.writeText('https://farts.com/#lab').then(ok, () => toast('Share this link: farts.com/#lab')); }
  catch (e) { toast('Share this link: farts.com/#lab'); }
});

const viz = $('#viz'), vctx = viz.getContext('2d');
let vizVisible = true;
if ('IntersectionObserver' in window) new IntersectionObserver(es => { vizVisible = es[0].isIntersecting; }).observe(viz);
function drawViz(t) {
  if (!vizVisible) return;
  const r = viz.getBoundingClientRect(), dpr = Math.min(2, window.devicePixelRatio || 1);
  const W = Math.round(r.width * dpr), Hh = Math.round(r.height * dpr);
  if (!W || !Hh) return;
  if (viz.width !== W || viz.height !== Hh) { viz.width = W; viz.height = Hh; }
  vctx.clearRect(0, 0, W, Hh);
  vctx.strokeStyle = 'rgba(196,218,243,.07)'; vctx.lineWidth = 1;
  for (let x = 0; x < W; x += 28 * dpr) { vctx.beginPath(); vctx.moveTo(x, 0); vctx.lineTo(x, Hh); vctx.stroke(); }
  const mid = Hh * 0.5;
  vctx.beginPath(); vctx.moveTo(0, mid); vctx.lineTo(W, mid); vctx.strokeStyle = 'rgba(196,218,243,.14)'; vctx.stroke();

  // live frequency bars (react to whatever is playing right now)
  const f = Sound.ready ? Sound.freq() : null;
  if (f) {
    const bars = 48, bw = W / bars;
    vctx.fillStyle = 'rgba(89,135,208,.34)';
    for (let i = 0; i < bars; i++) { const v = f[1 + i] / 255; const h = v * Hh * 0.4; vctx.fillRect(i * bw + 1, Hh - h, bw - 2 * dpr, h); }
  }

  if (!labWave) {             // nothing picked yet: idle line
    vctx.beginPath(); vctx.lineWidth = 2.5 * dpr; vctx.strokeStyle = '#FFD23F'; vctx.shadowColor = 'rgba(255,210,63,.6)'; vctx.shadowBlur = 16 * dpr;
    for (let x = 0; x <= W; x += 6) { const y = mid + Math.sin(x / (22 * dpr) + t * 2.2) * 3 * dpr * (RM ? 0 : 1); x ? vctx.lineTo(x, y) : vctx.moveTo(x, y); }
    vctx.stroke(); vctx.shadowBlur = 0;
    return;
  }

  // the selected fart's own waveform, drawn as a mirrored line; the part already heard lights up yellow
  const pk = labWave.peaks, pad = 18 * dpr, x0 = pad, x1 = W - pad, ww = x1 - x0, amp = Hh * 0.34;
  const n = Math.max(24, Math.min(pk.length, Math.round(ww / (3 * dpr))));
  const col = new Float32Array(n);
  for (let c = 0; c < n; c++) {
    const i0 = Math.floor(c * pk.length / n), i1 = Math.max(i0 + 1, Math.floor((c + 1) * pk.length / n));
    let m = 0; for (let i = i0; i < i1; i++) if (pk[i] > m) m = pk[i];
    col[c] = m;
  }
  const sm = new Float32Array(n);
  for (let c = 0; c < n; c++) sm[c] = (col[Math.max(0, c - 1)] + 2 * col[c] + col[Math.min(n - 1, c + 1)]) / 4;
  const el = (performance.now() - labWave.t0) / 1000, prog = Math.min(1, Math.max(0, el / labWave.dur)), playing = el < labWave.dur;
  const px = c => x0 + (c / (n - 1)) * ww, py = (c, sign) => mid - sign * Math.max(1.2 * dpr, sm[c] * amp);
  const shape = () => {
    vctx.beginPath(); vctx.moveTo(px(0), py(0, 1));
    for (let c = 1; c < n; c++) vctx.lineTo(px(c), py(c, 1));
    for (let c = n - 1; c >= 0; c--) vctx.lineTo(px(c), py(c, -1));
    vctx.closePath();
  };
  // not yet heard
  shape(); vctx.fillStyle = 'rgba(196,218,243,.10)'; vctx.fill();
  vctx.lineWidth = 1.5 * dpr; vctx.strokeStyle = 'rgba(196,218,243,.38)'; vctx.stroke();
  // heard so far (after it finishes, the whole shape stays lit)
  const cut = x0 + ww * (playing ? prog : 1);
  vctx.save(); vctx.beginPath(); vctx.rect(0, 0, cut, Hh); vctx.clip();
  shape(); vctx.fillStyle = playing ? 'rgba(255,210,63,.22)' : 'rgba(255,210,63,.14)'; vctx.fill();
  vctx.lineWidth = 2.5 * dpr; vctx.strokeStyle = playing ? '#FFD23F' : 'rgba(255,210,63,.75)';
  vctx.shadowColor = 'rgba(255,210,63,.6)'; vctx.shadowBlur = playing ? 16 * dpr : 6 * dpr; vctx.stroke();
  vctx.restore(); vctx.shadowBlur = 0;
  if (playing) {                // playhead
    vctx.fillStyle = '#FFFFFF'; vctx.fillRect(cut - dpr, mid - amp - 12 * dpr, 2 * dpr, (amp + 12 * dpr) * 2);
    const txt = `${el.toFixed(1)} / ${labWave.dur.toFixed(1)} sec`;
    if (txt !== labWave.shown) { labWave.shown = txt; $('#vizMeta').textContent = txt; }
  }
}

/* =========================================================
   FAQ + FORMS
   ========================================================= */
function handleForm(form, msg) {
  form.addEventListener('submit', e => {
    const bad = $$('input[required]', form).find(i => !i.value.trim() || (i.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(i.value.trim())));
    if (bad) { e.preventDefault(); bad.focus(); toast(bad.type === 'email' ? 'Enter an email like you@email.com.' : 'Fill in every field so we know who you are.'); return; }
    if (form.dataset.brevo) { e.preventDefault(); brevoJoin(form); return; }   // on farts.com: Brevo's sign-up form (list 16)
    if (form.dataset.shopify === 'customer') { e.preventDefault(); shopifyJoin(form); return; }   // farts.com without Brevo set up yet: Shopify's newsletter form
    e.preventDefault();
    toast(msg); form.reset(); Sound.squeeze();
  });
}
const TOOT_YES = 'You’re in the Toot Troop! Watch your inbox for new drops.';
function tootJoined(form) {
  const note = form && form.querySelector('.join-note');
  if (note) { note.innerHTML = '<b>You’re in the Toot Troop!</b> Watch your inbox for new drops.'; note.classList.add('join-ok'); note.setAttribute('role', 'status'); }
}
/* Brevo: the email goes to Brevo's own sign-up form (no keys involved). Success is shown only when Brevo says yes. */
async function brevoJoin(form) {
  if (form.dataset.busy) return;
  const btn = form.querySelector('[type=submit]'), label = btn.textContent;
  form.dataset.busy = '1'; btn.disabled = true; btn.textContent = 'Signing you up…';
  let res = null, data = null;
  try {
    const ctl = new AbortController(), timer = setTimeout(() => ctl.abort(), 15000);
    try { res = await fetch(form.action + (form.action.includes('?') ? '&' : '?') + 'isAjax=1', { method: 'POST', body: new FormData(form), credentials: 'omit', signal: ctl.signal }); }
    finally { clearTimeout(timer); }
    try { data = await res.clone().json(); } catch (e) {}
  } catch (e) { res = null; }
  form.dataset.busy = ''; btn.disabled = false; btn.textContent = label;
  if (res && res.ok && !(data && data.success === false)) { tootJoined(form); form.reset(); toast(TOOT_YES); Sound.squeeze(); return; }
  if (res) { toast('That didn’t go through. Check your email address and try again.'); return; }
  if (!navigator.onLine) { toast('You look offline. Check your connection and try again.'); return; }
  // no readable answer from Brevo: send the form the ordinary way; Brevo confirms on its own page or sends them back here
  HTMLFormElement.prototype.submit.call(form);
}
/* Shopify's newsletter form, sent in the background so the page doesn't reload. Shopify answers by sending the browser to
   ?customer_posted=true (signed up), back to the page with an error, or to a spam check (then the form is posted normally). */
async function shopifyJoin(form) {
  if (form.dataset.busy) return;
  const btn = form.querySelector('[type=submit]'), label = btn.textContent;
  form.dataset.busy = '1'; btn.disabled = true; btn.textContent = 'Signing you up…';
  let res = null, html = '';
  try {
    const ctl = new AbortController(), timer = setTimeout(() => ctl.abort(), 15000);
    try { res = await fetch(form.action.split('#')[0], { method: 'POST', body: new URLSearchParams(new FormData(form)), credentials: 'same-origin', signal: ctl.signal, headers: { Accept: 'text/html' } }); html = await res.text(); }
    finally { clearTimeout(timer); }
  } catch (e) { res = null; }
  form.dataset.busy = ''; btn.disabled = false; btn.textContent = label;
  if (res && /[?&]customer_posted=true/.test(res.url)) { tootJoined(form); form.reset(); toast(TOOT_YES); Sound.squeeze(); return; }
  if (res && res.ok && !/\/challenge/.test(res.url)) {
    let msg = '';
    try { const err = new DOMParser().parseFromString(html, 'text/html').querySelector('#joinForm .join-err'); msg = err ? err.textContent.replace(/\s+/g, ' ').trim() : ''; } catch (e) {}
    if (msg) { toast(msg); return; }
  }
  if (!res && !navigator.onLine) { toast('You look offline. Check your connection and try again.'); return; }
  HTMLFormElement.prototype.submit.call(form);   // a spam check or an unclear answer: let Shopify handle it on its own page
}
// back from a Toot Troop sign-up on farts.com: Shopify adds ?customer_posted=true; Brevo's form can send people back with ?toot=joined
if (/[?&](customer_posted=true|toot=joined)/.test(location.search)) {
  tootJoined(document.getElementById('joinForm'));
  setTimeout(() => toast('You’re in the Toot Troop! Watch your inbox for new drops.'), 600);
  try { history.replaceState(history.state, '', location.pathname + location.hash); } catch (e) {}
}
$('#soonNotify').addEventListener('click', e => {
  e.preventDefault();
  $('#join').scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'center' });
  setTimeout(() => { try { $('#joinEmail').focus({ preventScroll: true }); } catch (err) {} }, RM ? 0 : 650);
});
handleForm($('#joinForm'), 'Thanks! Toot Troop sign-ups open when the store launches.');

const mt = $('#marqueeTrack'); mt.innerHTML += mt.innerHTML;

/* =========================================================
   POOTER PILE: the game loads only when someone presses Play.
   Its code, styles and art live in separate files (game/ when hosted, or
   inert text blocks in this preview), and it uses its own audio, keys and
   storage, so the picker, cart, checkout and site sound are never touched.
   ========================================================= */
const PP_ASSETS = (window.FARTS_URLS && window.FARTS_URLS.game) || null;                               // build.py fills in the hosted file URLs
// Leaderboard server (Cloudflare Worker). Empty = no leaderboard: the game works exactly as before.
// On Shopify it comes from Theme settings > Leaderboard (window.FARTS_URLS.board).
const PP_BOARD = (window.FARTS_URLS && typeof window.FARTS_URLS.board === 'string' && window.FARTS_URLS.board) || '';
const ppClip = id => CLIP_URLS[id];        // build.py points this at the hosted audio files
const PP_CLIPS = ['straight', 'surprise', 'getaway', 'daddy', 'finale', 'momma'];
// Background music, one track per backdrop. Asked for one at a time, only when the game needs it:
// single file = read from an inert text block in this page; hosted = fetched from /game/ (build.py fills PP_ASSETS.music).
const ppMusic = id => (PP_ASSETS ? (PP_ASSETS.music && PP_ASSETS.music[id]) || null
  : (document.getElementById('pp-music-' + id) ? { b64: () => ppText('pp-music-' + id) } : null));
let ppLoading = null;
function ppText(id) { const el = document.getElementById(id); return el ? el.textContent.trim() : ''; }
// Single-file preview: the game script is already in the page (inert until opened), so nothing is fetched.
// Hosted site: fetch the game's own files the first time someone presses Play.
function ppLoad() {
  if (window.PooterPile) return Promise.resolve(window.PooterPile);
  if (!PP_ASSETS) return Promise.reject(new Error('the game script in this page did not run'));
  if (ppLoading) return ppLoading;
  const css = new Promise(res => {
    const l = document.createElement('link'); l.rel = 'stylesheet'; l.href = PP_ASSETS.css;
    l.onload = res; l.onerror = res;                   // the game still works if styles are slow
    document.head.appendChild(l);
    setTimeout(res, 4000);
  });
  const js = new Promise((res, rej) => {
    const sc = document.createElement('script'); sc.src = PP_ASSETS.js; sc.async = true;
    sc.onload = () => (window.PooterPile ? res(window.PooterPile) : rej(new Error('game script loaded but did not start')));
    sc.onerror = () => rej(new Error('could not download ' + PP_ASSETS.js));
    document.head.appendChild(sc);
  });
  ppLoading = Promise.all([js, css]).then(r => r[0]).catch(err => { ppLoading = null; throw err; });
  return ppLoading;
}
function ppShowBest() {
  let b = 0; try { b = JSON.parse(localStorage.getItem('pp-best')) | 0; } catch (e) {}
  const el = $('#ppBest'); if (!el) return;
  el.hidden = !b; el.querySelector('b').textContent = b;
}
function ppFail(err) {
  console.error('[Pooter Pile] could not start:', err);
  toast(PP_ASSETS ? 'Pooter Pile didn’t load. Check your connection and try again.'
                  : 'Pooter Pile couldn’t start in this viewer. Open the file in Chrome, Safari or Edge.');
}
function ppOpen(e) {
  if (e) e.preventDefault();
  const btns = $$('[data-pp-open]');
  if (btns.some(b => b.getAttribute('aria-busy') === 'true')) return;
  btns.forEach(b => b.setAttribute('aria-busy', 'true'));
  const done = () => btns.forEach(b => b.removeAttribute('aria-busy'));
  let p;
  try { p = ppLoad(); } catch (err) { p = Promise.reject(err); }
  p.then(PP => {
    const audio = {}; PP_CLIPS.forEach(id => { audio[id] = ppClip(id); });
    PP.open({ sprite: PP_ASSETS ? PP_ASSETS.sprite : ppText('pp-sprite'), audio, music: ppMusic, shop: '#shop', onClose: ppShowBest, board: PP_BOARD });
  }).catch(ppFail).then(done, done);
}
$$('[data-pp-open]').forEach(b => b.addEventListener('click', ppOpen));
ppShowBest();
// Leaderboard: a score still waiting on this device (no connection last time, or the page closed mid-run)
// is sent now, without loading the game. Same storage format as game/src/15-board.js; keep them in step.
function ppSendSaved() {
  const base = PP_BOARD.trim().replace(/\/+$/, '');
  if (!/^https:\/\/[a-z0-9.-]+(:\d+)?$/i.test(base) && !/^http:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/.test(base)) return;
  if (window.PooterPile && window.PooterPile.isOpen && window.PooterPile.isOpen()) return;
  let player, box, cur;
  try {
    player = JSON.parse(localStorage.getItem('pp-player') || 'null');
    box = JSON.parse(localStorage.getItem('pp-outbox') || '[]');
    cur = JSON.parse(localStorage.getItem('pp-current') || 'null');
  } catch (e) { return; }
  if (!player || !/^[0-9a-f]{64}$/.test(player.k || '')) return;
  if (!Array.isArray(box)) box = [];
  if (cur && cur.rid && Array.isArray(cur.delays) && cur.delays.length) {
    if (!box.some(b => b && b.rid === cur.rid)) box.push(cur);
    try { localStorage.setItem('pp-outbox', JSON.stringify(box)); localStorage.setItem('pp-current', 'null'); } catch (e) {}
  }
  const send = box.filter(b => b && b.rid && Array.isArray(b.delays)).slice(0, 10);
  if (!send.length) return;
  fetch(base + '/api/submit', { method: 'POST', credentials: 'omit', headers: { 'content-type': 'text/plain;charset=UTF-8' },
    body: JSON.stringify({ key: player.k, name: player.n, runs: send.map(b => ({ rid: b.rid, ticket: b.ticket || undefined, v: b.v, delays: b.delays, at: b.at })) }) })
    .then(r => (r.ok ? r.json() : null)).then(j => {
      if (!j || !Array.isArray(j.results)) return;
      const done = {}; j.results.forEach(r => { done[r.rid] = 1; });
      try {
        const now = JSON.parse(localStorage.getItem('pp-outbox') || '[]') || [];
        localStorage.setItem('pp-outbox', JSON.stringify(now.filter(b => !(b && done[b.rid] && send.some(s => s.rid === b.rid && s.delays.length === b.delays.length)))));
        if (j.ticket) localStorage.setItem('pp-ticket', JSON.stringify({ t: j.ticket, at: Date.now() }));
      } catch (e) {}
    }).catch(() => {});
}
setTimeout(ppSendSaved, 2000);
})();